import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  ActionIcon,
  Box,
  Button,
  Checkbox,
  Collapse,
  ComboboxItem,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  Menu,
  Modal,
  NumberFormatter,
  Pagination,
  Select,
  Switch,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
  useHover,
  useScrollIntoView,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBarcode,
  IconCheck,
  IconDeviceFloppy,
  IconMaximize,
  IconMaximizeOff,
  IconPencilDiscount,
  IconPlus,
  IconPrinter,
  IconRowInsertTop,
  IconSearch,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import {
  CellEditingStoppedEvent,
  CellValueChangedEvent,
  ColDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  IRichCellEditorParams,
  MenuItemDef,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import { MRT_RowSelectionState } from "mantine-react-table";
import moment from "moment";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import classesButton from "../../../../../src/Styles/StyleButton.module.css";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { anyAsciiCode } from "../../../../_base/helper/AnyAscii";
import { sky_blue } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { OrderDetailOutWardNew } from "../../../../model/SaleOrderModel";
import { SelectListItem } from "../../../../model/SelectListItem";
import {
  TblInventoryChildSerialOnhandCommand,
  TblInventorySerialItemDetailOnHand,
  TblInventorySerialOrderDetailOnHand,
} from "../../../../model/TblInventorySerialOnHand";
import {
  detailOrderForInWardModel,
  TblInWard,
  TblInwardDetail,
} from "../../../../model/TblInWard";
import { getTblInventoryTransactionTypeInWard } from "../../../../service/getSelectApi";
import { outward } from "../../WarehouseOutWard/services";
import AddProductBySerialModal from "../components/AddProductBySerialModal";
import ExchangeReturnInWard from "../components/ExchangeReturninWard";
import RequestFinishedProductionInWard from "../components/RequestFinishedProductionInWard";
import RequestOrderReturnInWard from "../components/RequestOrderReturnInWard";
import RequestTransferInWard from "../components/RequestTransferInWard";
import RequestVendorInWard from "../components/RequestVendorInWard";
import { visibleCol, visibleColDetail } from "../constants";
import { getActionFromPath } from "../utils";
import { DemoExportExcel } from "./DemoExportExcel/DemoExportExcel";
import OptionPrintInWard from "./OptionPrintOutWard";
import PrintTheReturnReceipt from "./PrintTheReturnReceipt";
import SerialStatusCustomAgGrid from "./SerialStatusCustomAgGrid";
import {
  SerialOnHand,
  TblInventoryChildSerialOnhandCommands,
} from "./warehouseInWardSerialChildren/warehouseInterFace";
import { WarehouseInWardSerialChildrenV2 } from "./warehouseInWardSerialChildren/warehouseInWardSerialChildrenV2";

interface TblInventorySerialOrderDetailOnHandEdit extends TblInventorySerialOrderDetailOnHand {
  type?: string;
  subPrice?: string;
  poPrice1?: number;
  isNoSerial?: boolean;
  soPrice1?: number;
  totalAmount?: number;
  note?: string | null;
  action?: any;
  returnReason?: string | null;
  tblInventoryChildSerialOnhandCommands?: TblInventoryChildSerialOnhandCommand[];
}

interface SelectModel {
  label: string;
  value: string;
}

// Tình trạng serial không cho chọn ở phiếu nhập kho
const EXCLUDED_SERIAL_STATUS_NAMES = [
  "Đổi mã",
  "Đang gửi nhà cung cấp",
  "Đã trả kho",
  "Test OK",
  "Trả khách",
  "Chờ test",
  "Test lỗi",
];

const WarehouseInWardActionV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const sourceCode = location.state && location.state?.sourceCode;
  // Khi mở ở tab mới (window.open) thì location.state rỗng nên đọc fallback từ query string
  const sourceType =
    (location.state && location.state?.sourceType) ??
    searchParams.get("sourceType");
  console.log(sourceType);
  const transactionCode =
    (location.state && location.state?.transactionCode) ??
    searchParams.get("transactionCode");
  const inputRef = React.useRef<HTMLInputElement>(null);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const locker =
    (location.state && location.state.isLocked) ??
    searchParams.get("isLocked") === "true";
  const id = location.state && location.state.id;
  const branchCode = location.state && location.state.branchCode;
  const action = getActionFromPath(location.pathname ?? "");
  const [serialChildren, setSerialChildren] = useState<
    TblInventoryChildSerialOnhandCommand[]
  >([]);
  const { scrollIntoView, targetRef } = useScrollIntoView<HTMLDivElement>({
    offset: 60,
  }) as {
    scrollIntoView: (options?: ScrollIntoViewOptions) => void;
    targetRef: React.RefObject<HTMLDivElement>;
  };
  const gridRef =
    React.useRef<AgGridReact<TblInventorySerialOrderDetailOnHandEdit>>(null);
  const gridRefDetail = React.useRef<AgGridReact<any>>(null);
  //Xử lý đóng model
  const [isMenuNone, setIsMenuNone] = useState<boolean | null>(null);
  const inputRefFocus = useRef<HTMLInputElement>(null);
  const { hovered, ref } = useHover();

  useEffect(() => {
    if (!isMenuNone && inputRefFocus.current) {
      setTimeout(() => {
        inputRefFocus.current?.focus();
      }, 100);
    }
  }, [isMenuNone]);
  //In phiếu nhập đổi trả
  const [isReadyToPrint, setIsReadyToPrint] = useState(false); //Biến để refetch khi trước khi in để lấy tỉnh phường xã
  const [idPrintCreate, setIdPrintCreate] = useState<number | null>(null); //state dùng để khi tạo tạo phiếu nhập kho thành công thì sẽ hiển thị nút in phiếu
  const [valuePrintOptionModal, setValuePrintOptionModal] = useState<{
    option1?: string;
    option2?: string;
    dichVuDiKem?: boolean;
  }>();
  // giá trị dc chọn từ modal in pxk
  const [openPrintHandover, setOpenPrintHandover] = useState(false); //giá trị  để hiển thị file in biên bản , nếu sét là true thì hiển thị

  const componentRef = React.useRef(null);
  const [currentDate, setCurrentDate] = useState<string>("");
  const [idPrint, setIdPrint] = useState<string | number>("");
  const [typePrint, setTypePrint] = useState<string | null>("");
  const [dataPrint, setDataPrint] = useState<any>(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
        @page{
          size: A4;
         margin: 7mm 0 7mm 0;
        }
        body:{
          margin: 0;
          color: #000;
        }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });

  //#region render ui outward
  const getInWardProps = (additionalProps = {}) => ({
    dataSearchSourceCodeOption,
    dataPosition,
    dataInWard: dataInWard?.tblItemTransactionHeaderCommand,
    dataOrderDetail: dataOrderDetail?.tblInventoryTransactionModel,
    userInfo,
    handleChangeValueInput,
    setSourceCode,
    handleKeyDownSourceCode,
    sourceCode,
    isSave,
    searchSourceCode,
    setSearchSourceCode,
    isLocked: locker,
    haveSourceCode: sourceCode,
    action,
    dataInventoryTransactionType,
    dataSerialStatus:
      dataSerialStatus && dataSerialStatus?.length > 0
        ? dataSerialStatus?.map((i) => ({
            label: i.label,
            value: i.label,
          }))
        : [],
    setSerialStatusSelectAll,
    dataSerialOnHand,
    dataBranch: dataMasterOrg,
    ...additionalProps,
  });

  const checkNhap = ["NHAP_DOI_TRA_TRUOC_2025", "NHAP_DOI_TRA"].includes(
    sourceType as string,
  );

  //Phân trang search
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Thong tin chung nhap lien chi nhanh
  const requestTransfetInWard = () => {
    return (
      <RequestTransferInWard
        {...getInWardProps({
          haveStatus: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };
  // Thong tin chung nhap noi bo
  const requestTransferInternalInWard = () => {
    return (
      <RequestTransferInWard
        {...getInWardProps({
          haveStatus: true,
          isInternal: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };
  // Thong tin chung nhap noi bo serial
  const requestTransferInternalSerialInWard = () => {
    return (
      <RequestTransferInWard
        {...getInWardProps({
          haveStatus: true,
          isInternal: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  // Thong tin chung nhap dieu chuyen noi bo
  const serialInWard = () => {
    return <RequestTransferInWard {...getInWardProps()} />;
  };

  // Thong tin chung nhap dieu chuyen noi bo serial
  const returnOrderInWard = () => {
    return (
      <RequestOrderReturnInWard
        {...getInWardProps({
          isInternal: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  const exchangeReturn = () => {
    return (
      <ExchangeReturnInWard
        {...getInWardProps({
          isInternal: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  // Thong tin chung nhap hang NCC
  const returnVendorInWard = () => {
    return (
      <RequestVendorInWard
        {...getInWardProps({
          isInternal: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  // Thong tin chung nhap thanh pham
  const requestFinishedProductInWard = () => {
    return (
      <RequestFinishedProductionInWard
        {...getInWardProps({
          haveStatus: true,
          isEdit: ["EDIT", "DETAIL"].includes(action),
        })}
      />
    );
  };

  //#region state
  const outWardEntity = {
    sourceId: 39,
    tblItemTransactionHeaderCommand: {
      transactionId: 0,
      transactionCode: "",
      transactionDate: "",
      sourceCode: sourceCode || transactionCode || "",
      sourceType: sourceType || "",
      inventoryId: null,
      subInvId: null,
      departmentId: 0,
      status: "NEW",
      description: "",
      atribute1: "",
      atribute2: "",
      atribute3: "",
      atribute4: "",
      atribute5: "",
      atribute6: "",
      atribute7: "",
      atribute8: "",
      atribute9: "",
      atribute10: "",
      createBy: 0,
      createName: "",
      createDate: moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss"),
      lastUpdateDate: "",
      lastUpdateBy: 0,
    },
    serials: [],
  };

  const [dataInWard, setDataInWard] = useState<TblInWard>(outWardEntity);
  const [handleItemCode, setHandleItemCode] = useState<boolean>(false);
  const [serialStatusSelectAll, setSerialStatusSelectAll] =
    useState<string>("");

  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [userInfo, setUserInfo] = useState<any>();

  //table state
  const entityOrderInWard = {
    tblInventoryTransactionModel: {},
    inventoryTransactionRequestSourceModels: [],
    invCode: null,
    invId: null,
    invName: null,
    outWardCode: null,
    receiver: null,
    sourceCode: null,
    sourceId: null,
    subInvId: null,
    toAddess: null,
  };

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataOrderDetail, setDataOrderDetail] =
    useState<OrderDetailOutWardNew>(entityOrderInWard);
  // Dùng để lấy thành phố và xã mới
  const [dataCommuneMoi, setDataCommuneMoi] = useState<SelectListItem[]>([]);
  const [serial, setSerial] = useState("");

  const [keySearch, setKeySearch] = useState<string>("");
  const [debounced] = useDebouncedValue(keySearch, 300, { leading: true });

  const [searchSourceCode, setSearchSourceCode] = useDebouncedState("", 300);
  const [dataItem, setDataItem] = useState<
    TblInventorySerialItemDetailOnHand[]
  >([]);
  const [dataSearchSourceCodeOption, setDataSearchSourceCodeOption] = useState<
    any[]
  >([]);
  const [dataSerialOnHand, setDataSerialOnHand] = useState<
    TblInventorySerialOrderDetailOnHandEdit[]
  >([]);
  const [dataPosition, setDataPosition] = useState<any[]>([]);
  const [dataSerialStatus, setDataSerialStatus] = useState<SelectModel[]>([]);
  const [dataMasterOrg, setDataMasterOrg] = useState<any[]>([]);

  const [checkDuplicateCode, setCheckDuplicateCode] = useState<string[]>([]);
  const [isExceedQuantity, setIsExceedQuantity] = useState(false);
  const [transactionTempId, setTransactionTempId] = useState(0);
  const [isSave, setIsSave] = useState(false);
  const [sourceCodeRef, setSourceCode] = useState(
    location.state && location.state.sourceCode,
  );
  const [isLockForOrder, setIsLockForOrder] = useState(true);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const sidePanelRef = React.useRef<HTMLDivElement>(null);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);

  const [openModals, setOpenModal] = useState(false); // State to manage modal visibility
  const [sheetNames, setSheetNames] = useState<string[]>([]); // State for sheet names
  const [selectedSheets, setSelectedSheets] = useState<string[]>([]); // State for selected sheets
  const [mainContentWidth, setMainContentWidth] = useState(0);
  const [workbook, setWorkbook] = useState<XLSX.WorkBook | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<
    TblInventorySerialOrderDetailOnHandEdit[]
  >([]);
  //#endregion

  //#region function
  const renderMainInWard = () => {
    const _sourceType =
      sourceType ?? dataInWard.tblItemTransactionHeaderCommand.sourceType;
    switch (_sourceType) {
      case "NHAP_HANG_NCC":
        return returnVendorInWard();
      case "NHAP_KHAC":
        return returnVendorInWard();
      case "NHAP_DIEU_CHUYEN_CHI_NHANH":
        return requestTransfetInWard();
      case "NHAP_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return serialInWard();
      case "NHAP_DIEU_CHUYEN_NOI_BO":
        return requestTransferInternalInWard();
      case "NHAP_CONG_CU_DUNG_CU":
        return requestTransferInternalInWard();
      case "NHAP_DIEU_CHUYEN_NOI_BO_SERIAL":
        return requestTransferInternalSerialInWard();
      case "NHAP_HANG_DOI_TRA":
        return returnOrderInWard();
      case "NHAP_DOI_TRA":
        return exchangeReturn();
      case "NHAP_DOI_TRA_TRUOC_2025":
        return exchangeReturn();
      case "NHAP_THANH_PHAM_SAN_XUAT":
        return requestFinishedProductInWard();
      default:
        return requestTransfetInWard();
    }
  };

  function removeVietnameseAccents(str: string): string {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D");
  }

  //#region import file Excel
  const handleFileUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx, .xls";
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        NotificationExtension.Warn("Không có tập tin nào được chọn");
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const binaryStr = event.target?.result;
          const loadedWorkbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetNames = loadedWorkbook.SheetNames;

          setWorkbook(loadedWorkbook);
          setSheetNames(sheetNames);
          setOpenModal(true);
        } catch (err) {
          console.error(err);
          NotificationExtension.Warn("Error processing the file");
        }
      };
      reader.readAsBinaryString(file);
    };
    input.click(); //j hàm mở chọn tệp
  };

  const modalConfirm = (status: string, isLocked?: boolean) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận !</Title>,
      children: (
        <Box mt={10} ta={"center"}>
          <Text fw={500} size="18px" style={{ lineHeight: 1.5 }}>
            Một số sản phẩm chưa có tình trạng serial, hệ thống sẽ tự động
            chuyển thành bán bình thường.
          </Text>
          <Text mt={5} fw={500} size="18px">
            Xác nhận để tiếp tục ?
          </Text>
          <Flex mt={10} justify={"center"} color="teal">
            <Button
              leftSection={<IconCheck size={16} />}
              onClick={() => handleCreateInWard(status, isLocked)}
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleExportExcel = () => {
    if (!dataSerialOnHand || dataSerialOnHand.length === 0) {
      NotificationExtension.Fails("Không có dữ liệu để xuất!");
      return;
    }

    const headers = [
      // { header: "Số thứ tự", key: "id" },
      { header: "Mã vị trí", key: "positionCode" },
      { header: "Tên vị trí", key: "positionName" },
      { header: "Mã hàng", key: "itemCode" },
      { header: "Serial", key: "serial" },
      { header: "Tên sản phẩm", key: "itemName" },
      { header: "ĐVT1", key: "primaryUomCode" },
      { header: "SL1", key: "primaryQuantity" },
      {
        header:
          dataInWard?.tblItemTransactionHeaderCommand?.sourceType === "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        key: "poPrice",
      },
      { header: "SL2", key: "subQuantity" },
      { header: "ĐVT2", key: "subUomName" },
      { header: "Thành tiền", key: "totalAmount" },
      { header: "Tình trạng", key: "status" },
      { header: "Ghi chú", key: "note" },
    ];

    const dataToExport = dataSerialOnHand.map((item) => ({
      positionCode: item.positionCode,
      positionName: item.positionName,
      itemCode: item.itemCode,
      serial: item.serial,
      itemName: item.itemName,
      primaryUomCode: item.primaryUomCode,
      primaryQuantity: item.primaryQuantity,
      poPrice:
        dataInWard?.tblItemTransactionHeaderCommand?.sourceType === "XUAT_BAN"
          ? item.soPrice && item.soPrice?.toLocaleString()
          : item.poPrice && item.poPrice?.toLocaleString(),
      subQuantity: item.subQuantity ?? "",
      subUomName: item.subUomName ?? "",
      totalAmount:
        dataInWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
          ? item?.soPrice &&
            (
              Number(item?.soPrice) * (item?.primaryQuantity || 0)
            )?.toLocaleString()
          : item?.poPrice &&
            (
              Number(item?.poPrice) * Number(item?.primaryQuantity || 0)
            )?.toLocaleString(),
      status: item.status ?? "",
      note: item.note ?? "",
    }));

    const formattedData = [
      headers.map((h) => h.header),
      ...dataToExport.map((item) => Object.values(item)),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    let currentDate = new Date();
    let day = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();
    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    let seconds = currentDate.getSeconds();

    let formattedDate = `${day < 10 ? "0" + day : day}-${
      month < 10 ? "0" + month : month
    }-${year}_${hours < 10 ? "0" + hours : hours}-${
      minutes < 10 ? "0" + minutes : minutes
    }-${seconds < 10 ? "0" + seconds : seconds}`;
    XLSX.utils.book_append_sheet(workbook, worksheet, "Phiếu nhập kho");
    XLSX.writeFile(workbook, `Phieu_nhap_kho_${formattedDate}.xlsx`);
  };

  const handleSheetSelection = async () => {
    if (!selectedSheets || selectedSheets.length === 0) {
      NotificationExtension.Warn("không có sheets để chọn");
      return;
    }

    if (!workbook) {
      NotificationExtension.Warn("No workbook loaded");
      return;
    }

    if (["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)) {
      // const allData = selectedSheets.flatMap((sheetName) => {
      //   const sheet = workbook.Sheets[sheetName];
      //   const jsonData = XLSX.utils.sheet_to_json(sheet);
      //   return jsonData.map((item: any) => ({
      //     itemCode: item["Mã hàng"] ?? null,
      //     itemName: item["Tên hàng"] ?? null,
      //     serialChildren: item["Số Serial"]
      //       ? String(
      //           removeVietnameseAccents(
      //             String(item["Số Serial"]).toUpperCase().trim()
      //           )
      //         )
      //       : null,
      //     quantity: item["Số lượng"] ?? null, // serial cha
      //     unitPrice: item["Giá nhập"] ?? null,
      //     uomCode: item["Đơn vị tính"] ?? null,
      //     warrantyPeriod: item["Thời gian BH serial con(tháng)"] ?? null,
      //     warrantyPeriodParent: item["Thời gian BH(tháng)"] ?? null,
      //     serial: item["Serial"]
      //       ? String(
      //           removeVietnameseAccents(
      //             String(item["Serial"]).toUpperCase().trim()
      //           )
      //         )
      //       : null,
      //   }));
      // });

      const allData = selectedSheets.flatMap((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        return jsonData.map((item: any) => ({
          itemCode: item["MÃ SP"] ?? null,
          itemName: item["TÊN SP"] ?? null,
          serialChildren: item["barcode con"]
            ? String(
                removeVietnameseAccents(
                  String(item["barcode con"]).toUpperCase().trim(),
                ),
              )
            : null,
          // quantity: item["Số lượng"] ?? null, // serial cha
          // unitPrice: item["Giá nhập"] ?? null,
          warrantyPeriod: item["Thời gian bảo hành"] ?? null,
          // warrantyPeriodParent: item["Thời gian BH(tháng)"] ?? null,
          serial: item["barcode cha"]
            ? String(
                removeVietnameseAccents(
                  String(item["barcode cha"]).toUpperCase().trim(),
                ),
              )
            : null,
          serialStatus:
            item["Tình trạng"] && String(item["Tình trạng"]).length > 0
              ? item["Tình trạng"]
              : null,
          attribute11:
            item["Ghi chú tình trạng"] &&
            String(item["Ghi chú tình trạng"]).length > 0
              ? item["Ghi chú tình trạng"]
              : null,
          serialStatusChild:
            item["Tình trạng serial con"] &&
            String(item["Tình trạng serial con"]).length > 0
              ? item["Tình trạng serial con"]
              : null,
          itemNameChild:
            item["TÊN SP CON"] && String(item["TÊN SP CON"]).length > 0
              ? item["TÊN SP CON"]
              : null,
        }));
      });

      const validData = allData.filter(
        (item) =>
          !dataSerialOnHand?.some(
            (existingItem) => existingItem.serial === item.serial,
          ),
      );

      const mappedCommands = validData.map((item) => ({
        itemCode: item.serialStatusChild,
        itemName: item.itemNameChild,
        serial: item.serialChildren
          ? String(
              removeVietnameseAccents(
                String(item.serialChildren).toUpperCase().trim(),
              ),
            )
          : null,
        // uomCode: item.uomCode,
        quantity: 1,
        warrantyPeriod: item.warrantyPeriod,
        parentSerial: item.serial
          ? String(
              removeVietnameseAccents(String(item.serial).toUpperCase().trim()),
            )
          : null,
        serialStatus:
          item.serialStatus && String(item.serialStatus).length > 0
            ? item.serialStatus
            : null,
        attribute11:
          item.attribute11 && String(item.attribute11).length > 0
            ? item.attribute11
            : null,
      }));

      setSerialChildren(mappedCommands ?? []);
      const serials = Array.from(
        new Set(
          validData
            .filter(
              (item) =>
                String(item.itemCode).toUpperCase().trim() ===
                String(keySearch).toUpperCase().trim(),
            )
            .map((item) => item.serial)
            .filter(
              (serial): serial is string => serial !== null && serial !== "",
            ),
        ),
      );

      if (serials.length === 0) {
        NotificationExtension.Fails(
          `Không tìm thấy serial cần nhập của mã hàng ${keySearch}, vui lòng kiểm tra lại file nhập !`,
        );
      }

      handleSerialsInput(serials);
    } else {
      const listSerials = selectedSheets.flatMap((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const jsonData: { Serial?: string | number }[] =
          XLSX.utils.sheet_to_json(sheet, { raw: false });
        return jsonData
          .map((row) => (row.Serial !== undefined ? String(row.Serial) : ""))
          .filter((serial) => serial.trim() !== "");
      });

      const uniqueSerials = [...new Set(listSerials)];

      //Lọc serial and status
      const serialMap = new Map();

      selectedSheets.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const jsonData: { Serial?: string | number }[] =
          XLSX.utils.sheet_to_json(sheet, { raw: false });

        jsonData.forEach((item) => {
          if (item.Serial && String(item.Serial).length > 0) {
            const serialStr = String(item.Serial).trim();

            // Chỉ thêm vào Map nếu Serial chưa tồn tại
            if (!serialMap.has(serialStr)) {
              serialMap.set(serialStr, item);
            }
          }
        });
      });

      const listSerialAndStatus = Array.from(serialMap.values());

      // if (uniqueSerials && uniqueSerials.length > 5000) {
      //   NotificationExtension.Warn(
      //     "Số lượng serial vượt quá 5000, vui lòng kiểm tra lại"
      //   );
      //   return;
      // }

      const skip = (currentPage - 1) * pageSize;

      const _sourceType =
        dataInWard.tblItemTransactionHeaderCommand?.sourceType ?? "";
      const _sourceCode =
        dataInWard.tblItemTransactionHeaderCommand?.sourceCode ?? sourceCodeRef;
      const _invId = dataInWard.tblItemTransactionHeaderCommand?.fromInvId ?? 0;
      try {
        const params = new URLSearchParams({
          KeySearch: debounced,
          SourceCode: _sourceCode,
          Skip: String(0),
          Take: String(500),
          // Skip: skip.toString(),
          // Take: pageSize.toString(),
          Type: _sourceType,
        });

        const body = {
          KeySearch: debounced,
          SourceCode: _sourceCode,
          Skip: 0, // hoặc skip
          Take: 500, // hoặc pageSize
          Type: _sourceType,
          ListSerials: uniqueSerials, // truyền danh sách serials
        };

        if (uniqueSerials.length === 0) {
          NotificationExtension.Fails("Không tìm thấy serial trong tệp Excel.");
          setOpenModal(false); // Close modal after selection
          return;
        }
        const url = `/api/v1/TblItemTransaction/search-list-serial-item-transaction`;

        const response = await repositoryPos.post<
          MessageResponse<TblInventorySerialOrderDetailOnHand[]>
        >(url, body);

        if (response && response.success) {
          const responseData = response.data;
          if (Array.isArray(responseData)) {
            const listDataSerialStatus = dataSerialStatus.map((i) => i.label);

            if (
              listSerialAndStatus.some(
                (i) =>
                  !listDataSerialStatus.includes(i.SerialStatus) &&
                  i.SerialStatus &&
                  String(i.SerialStatus).length > 0,
              )
            ) {
              NotificationExtension.Warn(
                "Danh sách sản phẩm có các sản phẩm chứa tình trạng serial không hợp lệ. Các sản phẩm này sẽ đổi tình trạng thành bán bình thường.",
              );
            }
            const updatedResponseData = responseData.map((item) => ({
              ...item,
              primaryQuantity: 1,
            }));

            const mergeArraysWithMap = () => {
              // Tạo Map từ array2 với key là Serial (chuẩn hóa về lowercase)
              const serialInfoMap = new Map();

              listSerialAndStatus.forEach((item) => {
                const serialKey = item.Serial?.toString().toLowerCase();
                if (serialKey) {
                  serialInfoMap.set(serialKey, {
                    status: item.SerialStatus,
                    note: item.SerialNote,
                  });
                }
              });

              // Map vào array1
              return updatedResponseData.map((item) => {
                const serialKey = item.serial?.toString().toLowerCase();
                const serialInfo = serialInfoMap.get(serialKey);

                // Tạo object kết quả với các giá trị mới
                return {
                  ...item,
                  serialStatus: serialInfo
                    ? listDataSerialStatus.includes(serialInfo.status)
                      ? serialInfo.status
                      : "Bán bình thường"
                    : item.serialStatus,
                  attribute11: serialInfo?.note || item.attribute11,
                };
              });
            };

            const checkData = [...dataSerialOnHand, ...mergeArraysWithMap()];

            // Loại bỏ phần tử trùng serial
            const uniqueData = checkData.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.serial === item.serial),
            );

            const checkQuantityBy =
              _sourceType === "NHAP_LINH_KIEN_SAN_XUAT"
                ? "limitQuantity"
                : "primaryQuantity";
            if (checkExceedQuantityFound(uniqueData, checkQuantityBy)) {
              NotificationExtension.Warn(
                "Sản phẩm vượt quá số lượng cần xuất, vui loại kiểm tra lại",
              );
            } else {
              if (checkDuplicateCode.includes(serial)) {
                NotificationExtension.Fails("Mã Serial đã được quét !");
              }
              setDataSerialOnHand((prevData) => [...uniqueData]);
              setCheckDuplicateCode((prev) => [
                ...prev,
                ...responseData
                  .map((item) => item.serial)
                  .filter((serial): serial is string => serial !== null),
              ]);
              NotificationExtension.Success("Import excel thành công !");
              // setCheckDuplicateCode((prev) => [
              //   ...prev,
              //   ...responseData
              //     .map((item) => item.serial)
              //     .filter((serial) => serial !== null),
              // ]);
            }
          }
        } else {
          NotificationExtension.Fails(response?.message || "");
        }

        if (response?.data?.length === 0) {
          NotificationExtension.Warn("Không tìm thấy sản phẩm !");
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
      }
    }

    setOpenModal(false); // Close modal after selection
  };

  // const handleOpenFileDrop = () => {
  //   try {
  //     modals.openConfirmModal({
  //       title: null,
  //       yOffset: "5%",
  //       withCloseButton: false,
  //       children: <DropZoneFile onImport={handleImportExcel}></DropZoneFile>,
  //       confirmProps: { display: "none" },
  //       cancelProps: { display: "none" },
  //     });
  //   } catch (e) {
  //     NotificationExtension.Fails("Import excel thất bại");
  //   }
  // };
  //Thêm hàng serial con
  const handleAddPlus = (
    value: string,
    item: TblInventoryChildSerialOnhandCommands[],
  ) => {
    setDataSerialOnHand((prev) => {
      return prev.map((ele) =>
        ele.serial === value
          ? { ...ele, tblInventoryChildSerialOnhandCommands: item }
          : ele,
      );
    });
  };
  //xóa hàng serial con
  const handleDeleteRow = (
    rowIndex: string,
    item: CellValueChangedEvent<TblInventoryChildSerialOnhandCommand>,
  ) => {
    setDataSerialOnHand((prev) =>
      prev.map((ele) => {
        if (String(ele.serial) === String(item?.data?.parentSerial)) {
          return {
            ...ele,
            tblInventoryChildSerialOnhandCommands:
              ele?.tblInventoryChildSerialOnhandCommands?.filter(
                (e) => e.serial !== rowIndex,
              ),
          };
        }
        return ele;
      }),
    );
  };

  const openModal = (items: SerialOnHand) => {
    return modals.openConfirmModal({
      title: <Title order={4}>Thông tin serial con</Title>,
      radius: "md",
      size: "90%",
      children: (
        <WarehouseInWardSerialChildrenV2
          type="NHAP"
          handleAddPlus={handleAddPlus}
          handleDeleteRow={handleDeleteRow}
          WarehouseInWardSerialChildren={items}
          action={action}
          sourceType={sourceType}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // func render ui => title
  const titleSell = () => {
    return (
      <>
        <Group mt={-10} align="center" justify="space-between">
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Tooltip label={"Ctrl + Shift + Z"} position="bottom">
              <Group align="center">
                <Switch
                  size="lg"
                  color={isCollapse ? "red" : "green"}
                  onLabel="Bật"
                  offLabel="Tắt"
                  checked={!isCollapse}
                  onChange={toggleCollapse}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              </Group>
            </Tooltip>
          </Flex>
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {/* <Button
              leftSection={<IconArrowLeft size={14} />}
              color="gray"
              onClick={() => handleReturnPage()}
            >
              Quay lại
            </Button> */}
            {["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) ? (
              <DemoExportExcel />
            ) : (
              <DemoExportExcel onLySerial={true} />
            )}
            <Button
              color="red"
              leftSection={<IconTrash size={14} />}
              rightSection={`(${selectedRows.length})`}
              onClick={handleDeleteSelected}
              className={classesButton.button}
              disabled={
                ["DETAIL"].includes(action)
                  ? ["DETAIL"].includes(action)
                  : !selectedRows.length
              }
            >
              Xóa đã chọn
            </Button>
            {/* hiển thị nút in khi vừa tạo xong phiếu nhập kho */}
            {dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" &&
              location.pathname ===
                "/warehouse-config/create-warehouse-in-ward" && (
                <>
                  {(dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
                    "NHAP_DOI_TRA" ||
                    dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
                      "NHAP_DOI_TRA_TRUOC_2025") && (
                    <Button
                      leftSection={<IconPrinter size={14} />}
                      color="violet"
                      onClick={() => {
                        if (
                          location?.state?.sourceType === "NHAP_DOI_TRA" ||
                          location?.state?.sourceType ===
                            "NHAP_DOI_TRA_TRUOC_2025"
                        ) {
                          idPrintCreate !== null &&
                            openPrintOptionModal(
                              idPrintCreate,
                              dataInWard?.tblItemTransactionHeaderCommand
                                ?.sourceType!,
                            );
                        } else {
                          idPrintCreate !== null &&
                            onhandlePrint(
                              idPrintCreate,
                              dataInWard?.tblItemTransactionHeaderCommand
                                ?.sourceType!,
                            );
                        }
                      }}
                    >
                      In phiếu nhập kho
                    </Button>
                  )}
                </>
              )}
            {dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" &&
              location.pathname ===
                "/warehouse-config/detail-warehouse-in-ward" && (
                <>
                  {(dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
                    "NHAP_DOI_TRA" ||
                    dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
                      "NHAP_DOI_TRA_TRUOC_2025") && (
                    <Button
                      leftSection={<IconPrinter size={14} />}
                      color="violet"
                      onClick={() => {
                        if (
                          location?.state?.sourceType === "NHAP_DOI_TRA" ||
                          location?.state?.sourceType ===
                            "NHAP_DOI_TRA_TRUOC_2025"
                        ) {
                          openPrintOptionModal(
                            location?.state.id,
                            location?.state?.sourceType,
                          );
                        } else {
                          onhandlePrint(
                            location?.state.id,
                            location?.state?.sourceType,
                          );
                        }
                      }}
                    >
                      In phiếu nhập kho
                    </Button>
                  )}
                </>
              )}
            {dataInWard?.tblItemTransactionHeaderCommand?.sourceType !==
              "NHAP_THANH_PHAM_SAN_XUAT" && (
              <Button
                type="submit"
                leftSection={<IconDeviceFloppy size={16} />}
                color={sky_blue.base}
                className={classesButton.button}
                disabled={
                  dataInWard.tblItemTransactionHeaderCommand.status ===
                    "LOCK" ||
                  locker ||
                  dataSerialOnHand?.length === 0
                }
                onClick={() => {
                  // setIsSave(true);
                  if (
                    dataSerialOnHand.some(
                      (i) => !i.serialStatus || i.serialStatus === "",
                    )
                  ) {
                    modalConfirm("OPEN", false);
                  } else {
                    handleCreateInWard("OPEN", false);
                  }
                }}
              >
                Lưu (Ctrl+S)
              </Button>
            )}
            <Button
              type="button"
              color="green"
              loading={isLoading}
              className={classesButton.button}
              leftSection={<IconCheck size={16} />}
              disabled={
                dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                locker ||
                isLockForOrder ||
                dataSerialOnHand?.length === 0
              }
              onClick={() => {
                if (
                  dataSerialOnHand.some(
                    (i) => !i.serialStatus || i.serialStatus === "",
                  )
                ) {
                  modalConfirm("LOCK", true);
                } else {
                  handleCreateInWard("LOCK", true);
                }
              }}
            >
              Hoàn thành (Ctrl+Q)
            </Button>
          </Flex>
        </Group>
      </>
    );
  };
  const openPrintOptionModal = (id: number, type: string) => {
    setOpenPrintHandover(false);
    modals.openConfirmModal({
      title: "Chọn loại phiếu Xuất Kho Bán",
      closeOnConfirm: false,
      size: "400px",
      children: (
        <OptionPrintInWard
          id={id}
          type={type}
          onhandlePrint={onhandlePrint}
          setValuePrintOptionModal={setValuePrintOptionModal}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const onhandlePrint = (id: string | number, type: string | null) => {
    if (id != null && type != null) {
      setIdPrint(id);
      setTypePrint(type);
    }
  };
  const fetchDataToPrint = async (id: number | string, type: string | null) => {
    let apiPath;
    const isDichVu = valuePrintOptionModal?.dichVuDiKem;
    switch (type) {
      case "NHAP_DOI_TRA":
        apiPath = isDichVu
          ? `/api/v1/Inward/print-in-ward-return?id=${id}&isserive=true`
          : `/api/v1/Inward/print-in-ward-return?id=${id}`;
        break;
      case "NHAP_DOI_TRA_TRUOC_2025":
        apiPath = isDichVu
          ? `/api/v1/Inward/print-in-ward-return?id=${id}&isserive=true`
          : `/api/v1/Inward/print-in-ward-return?id=${id}`;
        break;
      default:
        return;
    }
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(apiPath);
      if (response?.success && response?.data) {
        setDataPrint(response?.data);
      } else {
        console.log("error fetch data to print");
        setDataPrint(null);
        NotificationExtension.Fails("error fetch data to print");
      }
    } catch (error) {
      console.log("error fetch data to print", error);
    }
  };

  const getDataSerialStatus = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblSerialStatus/get-list?Skip=0&Take=100",
    );

    if (res && res.success) {
      const data = res.data
        .filter(
          (i: any) =>
            i.code &&
            i.name &&
            i.status === "Y" &&
            !EXCLUDED_SERIAL_STATUS_NAMES.includes(
              String(i.name).trim().normalize("NFC"),
            ),
        )
        .map((i: any) => ({
          label: String(i.name),
          code: String(i.code),
          value: String(i.id),
        }));

      setDataSerialStatus(data);
    }
  };

  useEffect(() => {
    if (sourceType !== "NHAP_HOI_LINH_KIEN") {
      getDataSerialStatus();
    }
  }, []);

  useEffect(() => {
    if (idPrint !== "") {
      fetchDataToPrint(idPrint, typePrint);
    }
  }, [idPrint]);

  useEffect(() => {
    if (dataPrint && dataPrint?.tblInventoryTransactionModel) {
      let idCheck: string | undefined = undefined;
      let paramType: "Ids" | "OldCommuneId" | undefined = undefined;
      const checkDvtn = dataPrint?.tblInventoryTransactionModel.dvtn;
      // Parse lại attribute3 từ dataPrint
      let parsedData: any | null = null;
      try {
        parsedData = dataPrint?.tblInventoryTransactionModel?.attribute3
          ? JSON.parse(dataPrint.tblInventoryTransactionModel.attribute3)
          : null;
      } catch (error) {
        parsedData = null;
      }
      // NOTE:CHUYỂN ĐỔI LOGIC LẤY HẾT ĐỊA CHỈ MỚI LÊN CHỈ DÙNG TYPE LÀ IDS THÔI
      if (checkDvtn) {
        // nếu là đơn vị tiếp nhận thì mặc định truyền vào OldComnunedId
        idCheck = parsedData?.customerCommuneId;
        paramType = "Ids";
      } else if (
        dataPrint &&
        dataPrint?.tblInventoryTransactionModel?.newCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ mới thì truyền vào Ids
        idCheck = dataOrderDetail.tblInventoryTransactionModel.newCommuneId;
        paramType = "Ids";
      } else if (
        dataPrint &&
        dataPrint?.tblInventoryTransactionModel?.cusCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ cũ thì truyền vào OldCommuneId

        idCheck = dataOrderDetail.tblInventoryTransactionModel?.cusCommuneId;
        paramType = "Ids";
      }
      // Api gọi Xã Phường Mới
      const fetchDataReceiptCommuneMoi = async () => {
        // if (!idCheck || !paramType) {
        //   setIsReadyToPrint(true); // Không cần fetch, vẫn cho phép in
        //   return;
        // }
        const response = await repositoryMdm.get<
          MessageResponse<SelectListItem[]>
        >(`/api/v1/TblDmCommuneMoi/get-select?${paramType}=${idCheck}`);
        if (response && response.success) {
          setDataCommuneMoi(response.data);
          setIsReadyToPrint(true); // Đánh dấu đã fetch xong
        }
      };
      setIsReadyToPrint(false); // Reset trước khi fetch
      fetchDataReceiptCommuneMoi();
    }
  }, [dataPrint, idPrint, dataOrderDetail]);
  useEffect(() => {
    if (
      dataPrint !== null &&
      isReadyToPrint // Đảm bảo đã fetch xong xã/phường mới
    ) {
      handlePrint();
      setIdPrint("");
      setDataPrint(null);
    }
  }, [dataPrint, isReadyToPrint]);
  useEffect(() => {
    const getCurrentDateFormatted = (): string => {
      const today = new Date();
      const day = today.getDate()?.toString().padStart(2, "0");
      const month = (today.getMonth() + 1)?.toString().padStart(2, "0");
      const year = today.getFullYear();

      return `${day}.${month}.${year}`;
    };
    setCurrentDate(getCurrentDateFormatted());
  }, []);
  // func render ui => select item outward
  const TableSelect = () => (
    <div ref={ref}>
      <Table.ScrollContainer
        minWidth={600}
        h={500}
        type="native"
        onClick={() => inputRefFocus.current?.focus()}
      >
        <Table striped highlightOnHover stickyHeader>
          <Table.Thead>
            <Table.Tr>
              <Table.Th />
              <Table.Th>Mã sản phẩm</Table.Th>
              <Table.Th>Tên sản phẩm</Table.Th>
              <Table.Th>Số serial</Table.Th>
              <Table.Th>Tuổi tồn</Table.Th>
              <Table.Th>Kho</Table.Th>
              <Table.Th>Đơn vị tính</Table.Th>
              {["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) && (
                <Table.Th>Hủy</Table.Th>
              )}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {dataItem?.map((item, index) => (
              <Table.Tr
                key={item.serial}
                bg={
                  checkDuplicateCode.some((select) => select === item.serial)
                    ? "var(--mantine-color-blue-light)"
                    : undefined
                }
              >
                <Table.Td>
                  {["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) ||
                  ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) ? (
                    <Button
                      size="xs"
                      variant="filled"
                      onClick={() => {
                        if (!checkDuplicateCode.includes(item.itemCode)) {
                          notFetchDataSerialOnhand(item);
                        }
                      }}
                      className={classesButton.button}
                      disabled={checkDuplicateCode.includes(item.itemCode)}
                    >
                      {checkDuplicateCode.includes(item.itemCode)
                        ? "Đã chọn"
                        : "Chọn"}
                    </Button>
                  ) : (
                    <Button
                      size="xs"
                      variant="filled"
                      onClick={() => {
                        fetchDataSerialOnHand(item.serial);
                      }}
                      className={classesButton.button}
                      disabled={checkDuplicateCode.includes(item.serial)}
                    >
                      {checkDuplicateCode.includes(item.serial)
                        ? "Đã chọn"
                        : "Chọn"}
                    </Button>
                  )}
                </Table.Td>
                <Table.Td>{item.itemCode}</Table.Td>
                <Table.Td>
                  <Tooltip label={item.itemName}>
                    <Text size="sm" w={150} lineClamp={2} truncate="end">
                      {item.itemName}
                    </Text>
                  </Tooltip>
                </Table.Td>
                <Table.Td>{item.serial}</Table.Td>
                <Table.Td>1</Table.Td>
                <Table.Td>
                  <Text size="sm" w={125} truncate="end">
                    {/* {item.subInvName} */}
                  </Text>
                </Table.Td>
                <Table.Td>1</Table.Td>
                <Table.Td>
                  {["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) && (
                    <Tooltip label="Hủy">
                      <ActionIcon
                        variant="transparent"
                        color="red"
                        onClick={() =>
                          handleCancelSelection(item.itemCode, item.serial)
                        }
                      >
                        <IconTrash size={20} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
          {dataItem?.length < 1 && (
            <Table.Caption>Không tìm thấy sản phẩm!</Table.Caption>
          )}
        </Table>
      </Table.ScrollContainer>
      <Group m={10} justify="end">
        <Pagination
          total={totalPages}
          value={currentPage}
          withEdges
          onChange={handlePageChange}
          mt="sm"
        />
        {/* <Button
                onClick={() => {
                  setTake((prevTake) => prevTake + 50);
                }}
                variant="transparent"
              >
                Xem thêm
              </Button> */}
      </Group>
    </div>
  );

  const isValidSerial = (input: string): boolean => {
    const pattern = /^[a-zA-Z0-9]+$/;
    if (input.length === 0) return true;
    return pattern.test(input);
  };

  // func render ui => text input transaction header
  const TextTransactionHeader = () => (
    <TextInput
      w={200}
      ref={inputRef}
      placeholder="Nhập mã vạch"
      className={classesButton.text_input}
      disabled={
        checkNhap
          ? !Boolean(
              dataInWard.tblItemTransactionHeaderCommand.toInvId?.toString(),
            ) ||
            dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
            ["DETAIL"].includes(action)
          : dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
            (["NHAP_HANG_NCC", "NHAP_KHAC"].includes(
              dataInWard?.tblItemTransactionHeaderCommand?.sourceType ?? "",
            ) &&
              dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
                (item) => item.itemCode === keySearch,
              )?.isNoSerial === true) ||
            ["DETAIL"].includes(action)
      }
      value={
        dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
          (item) => item.itemCode === keySearch,
        )?.isNoSerial === true
          ? keySearch
          : serial
      }
      leftSection={<IconBarcode size={20} />}
      onKeyDown={(e) => {
        if (e.key === " ") {
          e.preventDefault();
          return;
        }
        if (e.key === "Enter" && e.currentTarget.value.trim() !== "") {
          if (
            ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(
              dataInWard?.tblItemTransactionHeaderCommand?.sourceType ?? "",
            )
          ) {
            handleSerialInput(serial);
          } else handleAddProduct();
        }
      }}
      // error={
      //   !isValidSerial(anyAsciiCode(serial))
      //     ? "Serial không hợp lệ !"
      //     : undefined
      // }
      onChange={(e) =>
        setSerial(anyAsciiCode(e?.currentTarget?.value).toLocaleUpperCase())
      }
    />
  );

  // func render ui => select item transaction header
  const MenuDataOutWart = () => (
    <Menu
      opened={
        !isMenuNone &&
        debounced.length > 2 &&
        dataItem?.length !== 0 &&
        !["NHAP_HANG_NCC", "NHAP_KHAC"].includes(
          dataInWard?.tblItemTransactionHeaderCommand?.sourceType ?? "",
        )
      }
      trapFocus={false}
      shadow="md"
      width={"900px"}
      position="bottom-start"
    >
      <Menu.Target>
        <TextInput
          ref={inputRefFocus}
          key={keySearch}
          autoFocus
          leftSection={<IconSearch size={16} />}
          style={{ width: "200px" }}
          defaultValue={keySearch}
          className={classesButton.text_input}
          placeholder="Tìm kiếm mã sản phẩm"
          variant={
            ["DETAIL"].includes(action) || checkNhap
              ? !Boolean(
                  dataInWard.tblItemTransactionHeaderCommand.toInvId?.toString(),
                ) ||
                dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                ["DETAIL"].includes(action)
                ? "filled"
                : "default"
              : dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                  ["DETAIL"].includes(action)
                ? "filled"
                : "default"
          }
          onChange={(e) => {
            const _key = e.currentTarget.value ?? "";
            setKeySearch(_key);
          }}
          onBlur={() => {
            if (!hovered) {
              setIsMenuNone(true);
            }
          }}
          onClick={() => {
            setIsMenuNone(false);
          }}
        />
      </Menu.Target>
      <Menu.Dropdown>
        <TableSelect />
      </Menu.Dropdown>
    </Menu>
  );

  const RenderTransactionHeader = (type?: number) => {
    switch (type) {
      case 1:
        return ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
          ? MenuDataOutWart()
          : TextTransactionHeader();
      case 2:
        return ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
          ? TextTransactionHeader()
          : MenuDataOutWart();
      default:
        return null; // Trường hợp không khớp
    }
  };

  const RenderAddBarcodeButton = () => {
    if (sourceType === "NHAP_HANG_NCC") return null;
    const isDisabled =
      serial?.length < 3 ||
      dataInWard.tblItemTransactionHeaderCommand.status === "LOCK";
    return (
      <Grid.Col span={{ base: 6, md: 2, lg: 2 }}>
        <Button
          variant="filled"
          color="#228be6"
          leftSection={<IconPlus size={14} />}
          w="100%"
          onClick={handleAddProduct}
          disabled={isDisabled}
        >
          Thêm barcode
        </Button>
      </Grid.Col>
    );
  };

  const RenderSerialButtons = () => {
    if (!["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)) return null;
    const isDisabled = serial?.length < 3;

    return (
      <>
        <Button
          onClick={() =>
            handleSerialInput(
              serial ||
                (["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) &&
                  keySearch),
            )
          }
          className={classesButton.button}
          disabled={
            dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
              (item) => item.itemCode === keySearch,
            )?.isNoSerial === true
              ? false
              : isDisabled
          }
          leftSection={<IconPlus size={14} />}
        >
          Thêm
        </Button>
        <Button
          variant="outline"
          color="#228be6"
          className={classesButton.button}
          leftSection={<IconRowInsertTop size={20} />}
          onClick={() => {
            handleAddListProduct();
          }}
          disabled={!selectedItem || action === "DETAIL"}
        >
          Nhập serial theo chuỗi
        </Button>
      </>
    );
  };

  const handleCancelSelection = (itemCode: string, serial: string) => {
    // setDataSerialOnHand((prevData) =>
    //   prevData.filter(
    //     (item) => item.itemCode !== itemCode && item.serial !== serial
    //   )
    // );
    setSelectedItem([""]);
    setKeySearch("");
    setSerial("");
    setCheckDuplicateCode([""]);
    setCheckDuplicateCode((prevCodes) =>
      prevCodes.filter((code) => code !== itemCode && code !== serial),
    );
  };

  const handleReturnPage = () => {
    navigate(-1);
  };

  const handleKeyDownSourceCode = (e: any) => {
    if (e.key === "Enter" || e.key === "Tab") {
      if (dataSearchSourceCodeOption.length === 1) {
        handleChangeValueInput(searchSourceCode || "", "sourceCode");
      }
    }
  };

  const handleChangeValueInput = (
    value: null | string | boolean,
    key: string,
  ) => {
    setDataInWard((prevData) => ({
      ...prevData,
      tblItemTransactionHeaderCommand: {
        ...prevData.tblItemTransactionHeaderCommand,
        [key]: value,
      },
    }));
  };

  const handleAddProduct = () => {
    if (dataInWard.tblItemTransactionHeaderCommand?.sourceCode) {
      if (checkDuplicateCode.length === 0) {
        fetchDataSerialOnHand();
        setSerial("");
      } else if (checkDuplicateCode.length > 0) {
        if (checkDuplicateCode.includes(serial)) {
          NotificationExtension.Fails("Mã Serial đã được quét !");
        } else {
          fetchDataSerialOnHand();
          setSerial("");
        }
      }
    } else {
      NotificationExtension.Fails("Chưa nhập số chứng từ");
    }
  };

  const handleAddListProduct = () => {
    modals.openConfirmModal({
      size: "auto",
      withCloseButton: false,
      title: (
        <>
          <Title order={5}>Nhập serial theo chuỗi !</Title>
        </>
      ),
      children: (
        <AddProductBySerialModal
          onSubmit={handleSerialsInput}
          item={selectedItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const deleteItemSerial = (serial: string) => {
    setDataSerialOnHand((prevData) => {
      return prevData.filter((item) => item.serial !== serial);
    });
    setCheckDuplicateCode((prevData) =>
      prevData.filter((item) => item !== serial),
    );
  };

  const checkVarianceItem = (items: detailOrderForInWardModel[]) => {
    let variance = false;
    let variaceItems: { itemName: string; varianceQuantity: number }[] = [];
    items.forEach((item) => {
      const _varianceQuantity =
        (item.scannedQuantity || 0) - (item.primaryQuantity || 0);
      if (_varianceQuantity !== 0) {
        variaceItems = [
          ...variaceItems,
          {
            itemName: item.itemName,
            varianceQuantity: _varianceQuantity,
          },
        ];
        variance = true;
      }
    });
    return {
      isVariance: variance,
      variaceItems: variaceItems,
    };
  };

  const openCofirmModal = (variaceItems: any[]): Promise<boolean> => {
    return new Promise((resolve) => {
      modals.openConfirmModal({
        size: "40%",
        withCloseButton: false,
        children: (
          <Box component="form" mx="auto" style={{ position: "relative" }}>
            <Text size="20px" fw={"bold"} my={10}>
              Có những sản phẩm sau có lệch?
            </Text>
            <Box mt={3}>
              <Table
                highlightOnHover
                striped
                withColumnBorders
                horizontalSpacing="md"
                verticalSpacing="sm"
                bd={"1px solid #E0E0E0"}
              >
                <thead>
                  <tr style={{ backgroundColor: "#F8F9FD" }}>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 600,
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      Tên sản phẩm
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "12px",
                        fontSize: "16px",
                        fontWeight: 600,
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      Số lượng lệch
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {variaceItems?.map((item, index) => {
                    const varianceQuantity = [
                      "NHAP_HANG_NCC",
                      "NHAP_KHAC",
                    ].includes(sourceType)
                      ? item.scannedQuantity
                      : item.varianceQuantity || 0;
                    const primaryQuantity = item.primaryQuantity || 0;

                    //Tổng các số lượng lệch
                    const deviationAmount = [
                      "NHAP_HANG_NCC",
                      "NHAP_KHAC",
                    ].includes(sourceType)
                      ? varianceQuantity - primaryQuantity
                      : varianceQuantity - primaryQuantity;

                    return (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "bold",
                            textAlign: "left",
                            border: "1px solid #E0E0E0",
                          }}
                        >
                          {item.itemName || item.itemCode}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "red",
                            border: "1px solid #E0E0E0",
                          }}
                        >
                          {deviationAmount ?? 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Box>
            <Group
              justify="end"
              mt="xs"
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
              }}
            >
              <Button
                type="button"
                color="gray"
                onClick={() => {
                  handleChangeValueInput("", "status");
                  modals.closeAll();
                  resolve(false);
                }}
                leftSection={<IconX size={18} />}
              >
                Hủy
              </Button>
              {!["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) && (
                <Button
                  onClick={() => {
                    handleChangeValueInput("LOCK", "status");
                    modals.closeAll();
                    resolve(true);
                  }}
                  color={sky_blue.base}
                  leftSection={<IconCheck size={18} />}
                >
                  Xác nhận
                </Button>
              )}
            </Group>
          </Box>
        ),

        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
        onClose() {
          handleChangeValueInput("", "status");
        },
      });
    });
  };

  const checkExceedQuantityFound = (
    data: any[],
    fieldCheckQuantity?: string,
  ) => {
    const _sourceType = dataInWard.tblItemTransactionHeaderCommand.sourceType;
    const handeSupplierRequest =
      _sourceType === "NHAP_HANG_NCC" || _sourceType === "NHAP_KHAC";

    if (["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)) {
      const _exceedQuantityFound =
        dataOrderDetail?.inventoryTransactionRequestSourceModels?.some(
          (order) => {
            const matchingOrder = data
              .filter((item) => {
                const checkItem =
                  item.serial === order.serial ||
                  (handeSupplierRequest && item.itemCode === order.itemCode);
                return checkItem && !item.type;
              })
              .map((item) => item.primaryQuantity || 0); // Lấy số lượng và mặc định là 0 nếu undefined

            if (matchingOrder) {
              const totalQuantity = matchingOrder?.reduce(
                (acc, curr) => acc + curr,
                0,
              ); // Tính tổng số lượng
              const orderQuantity = order.primaryQuantity ?? 0;
              const orderTransferQuantity = order.transactionQuantity ?? 0;
              const remainQuantity =
                orderQuantity - (orderTransferQuantity + totalQuantity) || 0;

              return remainQuantity < 0;
            }

            return false;
          },
        );
      if (_exceedQuantityFound) {
        return true;
      }
      return false;
    } else {
      const _exceedQuantityFound =
        dataOrderDetail?.inventoryTransactionRequestSourceModels?.some(
          (order) => {
            const matchingOrder = data
              .filter((item) => {
                const checkItem = item.serial === order.serial;
                return checkItem && !item.type;
              })
              .map((item) => item.primaryQuantity || 0); // Lấy số lượng và mặc định là 0 nếu undefined
            if (matchingOrder.length > 0) {
              const totalQuantity = matchingOrder?.reduce(
                (acc, curr) => acc + curr,
                0,
              ); //code rác, tất cả tại thằng c Hoàng văn Kiều người lạng sơn huyện lộc bình thay đổi nghiệp vụ
              if (fieldCheckQuantity) {
                const orderQuantity = (order as any)[fieldCheckQuantity] ?? 0;
                const remainQuantity = orderQuantity - totalQuantity || 0;
                return remainQuantity < 0;
              }
            }

            return false;
          },
        );

      if (_exceedQuantityFound) {
        return true;
      }
      return false;
    }
  };

  const handleCreateInWard = async (status: string, isLocked?: boolean) => {
    const listSerialChild = dataSerialOnHand.flatMap(
      (i) => i.tblInventoryChildSerialOnhandCommands,
    );

    if (
      (dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
        "NHAP_HANG_NCC" ||
        dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
          "NHAP_KHAC") &&
      listSerialChild &&
      listSerialChild?.filter((iFill) => iFill)?.length > 0 &&
      listSerialChild
        ?.filter((iFill) => iFill)
        ?.some(
          (i: any) =>
            !i?.serial ||
            String(i?.serial).length === 0 ||
            !i?.itemCode ||
            String(i?.itemCode).length === 0 ||
            !i?.itemName ||
            String(i?.itemName).length === 0 ||
            i?.quantity !== 1 ||
            !i?.warrantyPeriod ||
            String(i?.warrantyPeriod).length === 0,
        )
    ) {
      NotificationExtension.Fails(
        `Vui lòng nhập đầy đủ thông tin serial con của các serial ${listSerialChild
          .filter(
            (i: any) =>
              !i?.serial ||
              String(i?.serial).length === 0 ||
              !i?.itemCode ||
              String(i?.itemCode).length === 0 ||
              !i?.itemName ||
              String(i?.itemName).length === 0 ||
              i?.quantity !== 1 ||
              !i?.warrantyPeriod ||
              String(i?.warrantyPeriod).length === 0,
          )
          .map((i: any) => i?.parentSerial)
          .join(", ")}`,
      );
      return;
    }

    if (dataSerialOnHand.some((item) => item.warning)) {
      NotificationExtension.Fails("Có sản phẩm không hợp lệ");
      return;
    }

    if (
      dataSerialOnHand.some(
        (item) => item.locatorId == null || item.locatorId === "",
      )
    ) {
      NotificationExtension.Fails("Có sản phẩm chưa có vị trí");
      return;
    }

    // if (isExceedQuantity) {
    //   NotificationExtension.Fails("Có sản phẩm vượt quá số lượng cần nhập");
    //   return;
    // }
    if (
      dataInWard?.tblItemTransactionHeaderCommand.description &&
      dataInWard?.tblItemTransactionHeaderCommand.description.length > 300
    ) {
      NotificationExtension.Fails("Ghi chú phiếu nhập không quá 300 ký tự");
      return;
    }
    // if (dataSerialOnHand.length > 5000) {
    //   NotificationExtension.Warn(
    //     "Số lượng serial vượt quá 5000, vui lòng kiểm tra lại"
    //   );
    //   return;
    // }

    setKeySearch("");
    handleChangeValueInput(status, "status");

    const serials = dataSerialOnHand?.map((item) => ({
      serialStatus:
        item.serialStatus && String(item.serialStatus).length > 0
          ? item.serialStatus
          : "Bán bình thường",
      attribute11:
        item.attribute11 && String(item.attribute11).length > 0
          ? item.attribute11
          : null,
      itemCode: item.itemCode,
      primaryQuantity: item.primaryQuantity,
      subQuantity: item.subQuantity ?? 0,
      serial: item.serial,
      invId:
        dataInWard?.tblItemTransactionHeaderCommand?.subInvId ||
        dataOrderDetail?.tblInventoryTransactionModel?.toInvId,
      note: item.note,
      locatorId: item.locatorId,
      tblInventoryChildSerialOnhandCommands:
        item.tblInventoryChildSerialOnhandCommands,
    }));

    const attributes = getAttributes(
      dataInWard.tblItemTransactionHeaderCommand.sourceType,
    );

    const dataCreate = {
      ...dataInWard,
      tblItemTransactionHeaderCommand: {
        ...dataInWard.tblItemTransactionHeaderCommand,
        createDate: dataInWard.tblItemTransactionHeaderCommand?.createDate,
        createBy: dataInWard.tblItemTransactionHeaderCommand?.createBy,
        createName: dataInWard.tblItemTransactionHeaderCommand?.createName,
        createRoleName:
          dataInWard.tblItemTransactionHeaderCommand?.createRoleName,
        transactionId:
          transactionTempId ||
          dataInWard.tblItemTransactionHeaderCommand.transactionId,
        transactionCode:
          dataOrderDetail.tblInventoryTransactionModel.transactionCode,
        transactionDate:
          dataInWard.tblItemTransactionHeaderCommand.transactionDate,
        sourceCode:
          dataOrderDetail.tblInventoryTransactionModel.sourceCode || sourceCode,
        sourceType: dataInWard.tblItemTransactionHeaderCommand.sourceType,
        branchId: dataOrderDetail?.tblInventoryTransactionModel?.toBranchId,
        subInvId:
          dataInWard?.tblItemTransactionHeaderCommand?.subInvId ||
          dataOrderDetail?.tblInventoryTransactionModel?.toInvId,
        departmentId: dataInWard.tblItemTransactionHeaderCommand?.departmentId,
        status,
        description: dataInWard.tblItemTransactionHeaderCommand.description,
        subSourceId: dataOrderDetail.tblInventoryTransactionModel?.subSourceId,
        toPositionId: dataInWard.tblItemTransactionHeaderCommand?.toPositionId,
        ...attributes,
      },
      serials,
      isLock: isLocked,
    };

    const url = getInwardApiUrl(
      "create",
      dataInWard.tblItemTransactionHeaderCommand.sourceType,
    );

    try {
      if (status === "LOCK") {
        setIsLoading(true);
        const variance = checkVarianceItem(
          dataOrderDetail?.inventoryTransactionRequestSourceModels,
        );
        if (variance.isVariance) {
          const confirm = await handleMismatch();
          if (!confirm) {
            handleChangeValueInput("OPEN", "status");
            return;
          }
        }
        const lockResponse = await postInwardRequest(url, dataCreate);
        if (lockResponse?.success) {
          handleChangeValueInput("LOCK", "status");
          handleChangeValueInput(Date().toString(), "finishDate");
          setDataSerialOnHand(() =>
            dataSerialOnHand.map((i) =>
              i.serialStatus && String(i.serialStatus).length === 0
                ? { ...i, serialStatus: "Bán bình thường" }
                : i,
            ),
          );
          if (
            dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
              "NHAP_DOI_TRA" ||
            dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
              "NHAP_DOI_TRA_TRUOC_2025"
          ) {
            setIdPrintCreate(Number(lockResponse?.data?.data));
            // setTimeout(
            //   () =>
            //     onhandlePrint(
            //       lockResponse?.data?.data,
            //       dataCreate?.tblItemTransactionHeaderCommand?.sourceType
            //     ),
            //   1000
            // );
          }
          setIsLoading(true);

          NotificationExtension.Success("Khóa phiếu nhập kho thành công");
          modals.closeAll();
        } else {
          setIsLoading(false);
          handleChangeValueInput("", "status");
        }
        return;
      } else if (status === "OPEN") {
        const response = await postInwardRequest(url, dataCreate);
        if (response && status === "OPEN") {
          handleChangeValueInput("OPEN", "status");
          setTransactionTempId(response?.data.data ?? response?.data);
          setDataSerialOnHand(() =>
            dataSerialOnHand.map((i) =>
              !i.serialStatus || String(i.serialStatus).length === 0
                ? { ...i, serialStatus: "Bán bình thường" }
                : i,
            ),
          );
          NotificationExtension.Success("Lưu phiếu nhập kho thành công");
          modals.closeAll();
        } else {
          handleChangeValueInput("", "status");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMismatch = async () => {
    let hasUnmatchedItems = false;
    const handelBill = dataOrderDetail?.inventoryTransactionRequestSourceModels;

    dataSerialOnHand.forEach((serialOnHand) => {
      const primaryQuantity = serialOnHand.primaryQuantity ?? 0;

      const matchingItem = handelBill?.find((item) =>
        ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
          ? item.itemCode === serialOnHand.itemCode
          : item.serial === serialOnHand.serial,
      );

      if (matchingItem) {
        const difference = matchingItem.primaryQuantity - primaryQuantity;
        if (difference !== 0) {
          hasUnmatchedItems = true;
        }
      }
    });

    const unmatchedItems = handelBill?.filter(
      (itemInWard) =>
        !dataSerialOnHand.some(
          (serialOnHand) => serialOnHand.serial === itemInWard.serial,
        ),
    );

    if (unmatchedItems?.length) {
      hasUnmatchedItems = await openCofirmModal(unmatchedItems);
    }

    return hasUnmatchedItems;
  };

  const postInwardRequest = async (url: string, dataCreate: any) => {
    const response = await repositoryPos.post<MessageResponse<any>>(
      url,
      dataCreate,
    );
    if (response?.httpStatusCode === 200 && response?.success) {
      return response;
    } else {
      return null;
    }
  };
  //#region Tìm kiếm serial
  const fetchDataSerialOnHand = async (serialCode?: string) => {
    const _sourceCode =
      dataInWard.tblItemTransactionHeaderCommand?.sourceCode || sourceCode;
    let url = `?SourceCode=${_sourceCode}&Type=${
      dataInWard.tblItemTransactionHeaderCommand.sourceType
    }&Serial=${serialCode || serial}&IsNoSerial=${
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
        (item) => item?.itemCode === keySearch,
      )?.isNoSerial ?? ""
    }`;

    try {
      const response = await repositoryPos.post<
        MessageResponse<TblInventorySerialOrderDetailOnHand>
      >(`api/v1/TblItemTransaction/search-serial-item-transaction`, {
        serial: serialCode || serial,
        sourceCode: _sourceCode,
        type: dataInWard.tblItemTransactionHeaderCommand.sourceType,
        invId: dataInWard.tblItemTransactionHeaderCommand?.fromInvId,
        branchId: 0,
        isNoSerial:
          dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
            (item) => item?.itemCode === keySearch,
          )?.isNoSerial ?? "",
      });

      if (response && response.success) {
        const responseData = response.data;

        if (responseData.warning) {
          NotificationExtension.Fails(responseData.warning);
        } else {
          const dataDetail = {
            ...responseData,
            subInvName: responseData.invName,
            note: null,
            locatorId:
              dataInWard?.tblItemTransactionHeaderCommand?.toPositionId,
            positionCode: dataPosition?.find(
              (p) =>
                p.value?.toString() ===
                dataInWard?.tblItemTransactionHeaderCommand?.toPositionId?.toString(),
            )?.code,
          };
          const checkData = [...dataSerialOnHand, { ...dataDetail }];
          if (checkExceedQuantityFound(checkData)) {
            NotificationExtension.Warn(
              "Sản phẩm vượt quá số lượng cần nhập, vui lòng kiểm tra lại",
            );
          } else {
            setDataSerialOnHand((prevData) => [...prevData, { ...dataDetail }]);
            setCheckDuplicateCode((prev) => [...prev, serialCode || serial]);
          }
        }
      } else {
        NotificationExtension.Fails(response?.message || "");
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
  };

  const fetchDataPosition = async (fromInvId: number) => {
    try {
      const response = await outward.getSelectItemPosition(fromInvId);

      if (response?.success && Array.isArray(response.data)) {
        const mappedData = response.data.map((p) => ({
          label: `${p.positionCode} - ${p.positionName}`,
          value: p.id?.toString() || "",
          code: p.positionCode?.toString() || "",
        }));

        setDataPosition(mappedData);
      } else {
        setDataPosition([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataBranch = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const data = res.data.map((i: any) => ({
        orgId: i.id,
        orgCode: i.code,
      }));
      setDataMasterOrg(data);
    }
  };

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    if (checkNhap) {
      if (dataInWard.tblItemTransactionHeaderCommand.subInvId) {
        setDataSerialOnHand((prev) =>
          prev.map((i) => ({
            ...i,
            locatorId: "",
            positionCode: "",
          })),
        );
      }
    }
  }, [dataInWard.tblItemTransactionHeaderCommand.subInvId]);

  //#region xem chi tiết
  const fetchData = async () => {
    let url = getInwardApiUrl(null, sourceType);
    try {
      if (transactionCode) {
        url += `?transactionCode=${transactionCode}`;
      } else {
        url += `?id=${id}`;
      }
      const response = await repositoryPos.get<
        MessageResponse<TblInwardDetail>
      >(`${url}`);
      if (response?.success && response?.data) {
        setDataInWard((prevData) => ({
          ...prevData,
          tblItemTransactionHeaderCommand:
            response?.data?.tblInventoryTransactionModel,
        }));
        setDataOrderDetail((prevData) => ({
          ...prevData,
          inventoryTransactionRequestSourceModels:
            response?.data?.inventoryTransactionRequestSourceModels?.map(
              (order) => {
                const matchingItem = dataSerialOnHand
                  .filter(
                    (item) =>
                      item.serial === order.serial ||
                      item.itemCode === order.itemCode,
                  )
                  .map((item) => item.primaryQuantity || 0);

                const totalQuantity = matchingItem?.reduce(
                  (acc, curr) => acc + curr,
                  0,
                );
                const orderQuantity = order.primaryQuantity ?? 0;
                const orderTransferQuantity = order.transactionQuantity ?? 0;
                const remainQuantity =
                  orderQuantity - (orderTransferQuantity + totalQuantity) || 0;

                return {
                  ...order,
                  scannedQuantity: totalQuantity,
                  remainQuantity: remainQuantity,
                };
              },
            ),
          tblInventoryTransactionModel:
            response?.data?.tblInventoryTransactionModel,
        }));

        setDataSerialOnHand(
          response?.data.inventoryTransactionSerialModels.map((item) => ({
            ...item,
            primaryQuantity: item.primaryQuantity || 0,
            type: "scanned",
          })) || [],
        );
        setCheckDuplicateCode((prev) => [
          ...prev,
          ...response.data.inventoryTransactionSerialModels
            .map((item) => item.serial)
            .filter((serial): serial is string => serial !== null),
        ]);
        if (response?.data?.tblInventoryTransactionModel?.toInvId)
          fetchDataPosition(
            response?.data?.tblInventoryTransactionModel?.toInvId,
          );
      } else {
        setDataOrderDetail(entityOrderInWard);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataOrderDetail(entityOrderInWard);
    }
  };

  const getInwardApiUrl = (
    submitAction: string | null,
    sourceType: string | null,
  ): string => {
    const _action = submitAction ?? action.toLowerCase();
    switch (sourceType) {
      case `NHAP_HANG_NCC`:
        return `/api/v1/Inward/${_action}-in-ward-po`;
      case `NHAP_KHAC`:
        return `/api/v1/Inward/${_action}-in-ward-po`;
      case `NHAP_DIEU_CHUYEN_CHI_NHANH`:
        return `/api/v1/Inward/${_action}-in-ward-request-transfer`;
      case `NHAP_DIEU_CHUYEN_CHI_NHANH_SERIAL`:
        return `/api/v1/Inward/${_action}-request-transfer-internal-inward-serial`;
      case `NHAP_DIEU_CHUYEN_NOI_BO`:
        return `/api/v1/Inward/${_action}-request-transfer-internal-inward`;
      case `NHAP_DIEU_CHUYEN_NOI_BO_SERIAL`:
        return `/api/v1/Inward/${_action}-request-transfer-internal-inward-serial`;
      case `NHAP_HANG_DOI_TRA`:
        return `/api/v1/Inward/${_action}-in-ward-return`;
      case `NHAP_DOI_TRA`:
        return `/api/v1/Inward/${_action}-in-ward-return`;
      case `NHAP_DOI_TRA_TRUOC_2025`:
        return `/api/v1/Inward/${_action}-in-ward-return`;
      case `NHAP_THANH_PHAM_SAN_XUAT`:
        return `/api/v1/Inward/${_action}-in-ward-mfg-finished-goods`;
      case `NHAP_KHO_BAO_HANH`:
        return `/api/v1/Outward/${_action}-warranty-out-ward`;
      case `NHAP_KHO_BAO_HANH_NCC`:
        return `/api/v1/Inward/${_action}-common`;
      case "NHAP_THAO_DO":
        return `/api/v1/Inward/${_action}-common`;
      case "NHAP_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT":
        return `/api/v1/Inward/${_action}-common`;
      case "NHAP_MUON_BAO_HANH":
        return `/api/v1/Inward/${_action}-common`;
      case "NHAP_CONG_CU_DUNG_CU":
        return `/api/v1/Inward/${_action}-asset-inward`;
      case "NHAP_HOI_LINH_KIEN_SAN_XUAT":
        return `/api/v1/Inward/${_action}-return-material-inward`;
      default:
        throw new Error("Unknown source type");
    }
  };

  const getAttributes = (
    sourceType: string | null,
  ): { attribute4: string; attribute5: string } => {
    const { fromInvName, cusCode, cusName, toInvName } =
      dataOrderDetail?.tblInventoryTransactionModel || {};

    switch (sourceType) {
      case "NHAP_HANG_NCC":
      case "NHAP_KHAC":
      case "NHAP_HANG_DOI_TRA":
      case "NHAP_DOI_TRA":
      case "NHAP_DOI_TRA_TRUOC_2025":
        return {
          attribute4: fromInvName,
          attribute5: `${cusCode} - ${cusName}`,
        };
      default:
        return {
          attribute4: fromInvName,
          attribute5: toInvName,
        };
    }
  };

  //#region sửa
  const fetchDataInWard = async () => {
    const _sourceCode =
      dataInWard?.tblItemTransactionHeaderCommand?.sourceCode ||
      searchSourceCode;
    const _sourceType =
      dataInWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;
    let url = getInwardApiUrl(null, _sourceType);
    if (_sourceType === "NHAP_HOI_LINH_KIEN") {
      url += `?sourceCode=${_sourceCode}`;
    } else {
      url += `?prefix=NK&SourceCode=${_sourceCode}&SourceType=${_sourceType}`;
    }
    if (branchCode) {
      url += `&BranchCode=${branchCode}`;
    }
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response?.success) {
        setDataInWard((prevData) => ({
          ...prevData,
          tblItemTransactionHeaderCommand: {
            ...prevData.tblItemTransactionHeaderCommand,
            transactionCode:
              response?.data?.tblInventoryTransactionModel?.transactionCode,
            sourceDescription:
              response?.data?.tblInventoryTransactionModel?.sourceDescription ??
              null,
          },
        }));
        const dataDetail = response?.data;
        if (_sourceType === "NHAP_THANH_PHAM_SAN_XUAT") {
          const inventoryTransactionRequestSourceModels =
            response?.data?.inventoryTransactionRequestSourceModels.map(
              (item: any) => ({
                ...item,
                primaryQuantity: item.primaryQuantity,
              }),
            );
          dataDetail.inventoryTransactionRequestSourceModels =
            inventoryTransactionRequestSourceModels;
        }
        if (response?.data?.tblInventoryTransactionModel?.toInvId)
          fetchDataPosition(
            checkNhap
              ? Number(dataInWard?.tblItemTransactionHeaderCommand?.subInvId)
              : response?.data?.tblInventoryTransactionModel?.toInvId,
          );
        setDataOrderDetail(dataDetail);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useHotkeys([
    [
      "ctrl+S",
      () => {
        if (
          dataSerialOnHand.some((i) => !i.serialStatus || i.serialStatus === "")
        ) {
          modalConfirm("OPEN");
        } else {
          handleCreateInWard("OPEN");
        }
      },
    ],
    [
      "ctrl+Q",
      () => {
        if (
          dataSerialOnHand.some((i) => !i.serialStatus || i.serialStatus === "")
        ) {
          modalConfirm("LOCK", true);
        } else {
          handleCreateInWard("LOCK", true);
        }
      },
    ],
    ["ctrl+shift+Z", () => toggleCollapse()],
  ]);

  //#endregion

  const fetchdataInventoryTransactionType = async () => {
    const responseInWard = await getTblInventoryTransactionTypeInWard();

    setDataInventoryTransactionType(
      responseInWard.map((type) => ({ value: type.value, label: type.text })),
    );
  };

  // Get data sản phẩm
  const fetchDataItem = async () => {
    const skip = (currentPage - 1) * pageSize;
    const _sourceType =
      dataInWard?.tblItemTransactionHeaderCommand?.sourceType || sourceType;
    const _sourceCode =
      dataInWard.tblItemTransactionHeaderCommand?.sourceCode ?? sourceCode;
    // const _sourceCode =
    //   _sourceType === "NHAP_HANG_NCC"
    //     ? dataInWard.tblItemTransactionHeaderCommand?.subSourceId
    //     : dataInWard.tblItemTransactionHeaderCommand?.sourceCode ?? sourceCode;
    if (debounced && _sourceType && _sourceCode) {
      try {
        let url = `/api/v1/TblItemTransaction/search-list-serial-item-transaction?KeySearch=${debounced}&SourceCode=${_sourceCode}&Skip=${skip}&Take=${pageSize}&Type=${_sourceType}`;
        const response = await repositoryPos.get(url);
        setTotalPages(
          response.totalCount ? Math.ceil(response.totalCount / pageSize) : 1,
        );
        setDataItem(response?.data || []);
      } catch (error) {
        setDataItem([]);
      }
    }
  };

  const handleSerialInput = async (serial: any) => {
    //Kiểm tra xem với các mục có isNoSerial === true chỉ cho thêm 1 hàng duy nhất
    const y = dataSerialOnHand.filter(
      (e) => e.itemCode === keySearch && e.isNoSerial,
    );

    if (y.length >= 1) {
      NotificationExtension.Warn(`Có nhiều mục trùng ${keySearch}`);
      return;
    }

    if (typeof serial === "string") {
      const _sourceCode =
        dataInWard.tblItemTransactionHeaderCommand?.sourceCode || sourceCode;

      let url = `?SourceCode=${_sourceCode}&Type=${dataInWard.tblItemTransactionHeaderCommand.sourceType}&Serial=${serial}`;
      if (
        !["NHAP_HANG_NCC", "NHAP_KHAC"].includes(
          dataInWard?.tblItemTransactionHeaderCommand?.sourceType ?? "",
        )
      ) {
        try {
          const response = await repositoryPos.post<
            MessageResponse<TblInventorySerialOrderDetailOnHand>
          >(`api/v1/TblItemTransaction/search-serial-item-transaction`, {
            serial: serial,
            sourceCode: _sourceCode,
            type: dataInWard.tblItemTransactionHeaderCommand.sourceType,
            invId: dataInWard.tblItemTransactionHeaderCommand?.fromInvId,
            branchId: 0,
            isNoSerial:
              dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
                (item) => item?.itemCode === keySearch,
              )?.isNoSerial ?? "",
          });
          if (!response || !response.success) {
            return;
          }
        } catch (error) {
          setIsError(true);
          console.error("Error fetching serial data:", error);
          return;
        }
      }
      if (selectedItem && serial) {
        const isSerialDuplicate = dataSerialOnHand?.some(
          (item) => item.serial === serial,
        );
        if (isSerialDuplicate) {
          NotificationExtension.Warn(
            `Mã serial "${serial}" đã tồn tại, vui lòng nhập mã khác`,
          );
          return;
        }

        const matchingItemInArray2 =
          dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
            (item) => item.itemCode === selectedItem?.itemCode,
          );
        if (matchingItemInArray2) {
          const totalAddedQuantityForItem =
            dataSerialOnHand
              ?.filter((item) => item.itemCode === selectedItem?.itemCode)
              ?.reduce((sum, item) => sum + (item.primaryQuantity || 0), 0) ||
            0;
          const totalPrimaryQuantityForItem =
            matchingItemInArray2.primaryQuantity || 0;

          if (totalAddedQuantityForItem < totalPrimaryQuantityForItem) {
            setDataSerialOnHand((prevData) => [
              {
                ...selectedItem,
                serial,
                invId: dataInWard?.tblItemTransactionHeaderCommand?.sourceCode,
                primaryQuantity: 1,
                locatorId:
                  dataInWard?.tblItemTransactionHeaderCommand?.toPositionId ??
                  "",
                positionCode:
                  dataPosition?.find(
                    (p) =>
                      p.value?.toString() ===
                      dataInWard?.tblItemTransactionHeaderCommand?.toPositionId?.toString(),
                  )?.code ?? "",
              },
              ...prevData,
            ]);
            setSerial("");
          } else {
            NotificationExtension.Fails(
              "Sản phẩm vượt quá số lượng cần nhập, vui lòng kiểm tra lại",
            );
          }
        } else {
          NotificationExtension.Fails(
            "Không tìm thấy sản phẩm trong danh sách nhập, vui lòng kiểm tra lại",
          );
        }
      }
    } else if (Array.isArray(serial)) {
      if (selectedItem && serial) {
        const matchingItemInArray2 =
          dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
            (item) => item.itemCode === selectedItem?.itemCode,
          );
        if (matchingItemInArray2) {
          const checkQuantityAddExcel =
            matchingItemInArray2.primaryQuantity > serial.length;
          if (checkQuantityAddExcel) {
            serial.forEach((serialItem: any) => {
              setDataSerialOnHand((prev) => [
                {
                  ...selectedItem,
                  serial: serialItem.serial,
                  invId:
                    dataInWard?.tblItemTransactionHeaderCommand?.sourceCode,
                  primaryQuantity: 1,
                },
                ...prev,
              ]);
            });
            NotificationExtension.Success("Import sản phẩm thành công");
          } else {
            NotificationExtension.Fails(
              "Sản phẩm vượt quá số số lượng cần nhập, vui lòng kiểm tra lại",
            );
          }
        }
      } else {
        NotificationExtension.Fails("Chưa nhập mã sản phẩm");
      }
    } else {
      console.log("Serial is neither a string nor an array:", serial);
    }
  };

  const handleSerialsInput = (serials: string[]) => {
    let tempSerials = [...(dataSerialOnHand || [])];

    for (const serial of serials) {
      if (!serial) continue;

      const isSerialDuplicate = tempSerials.some(
        (item) => item.serial === serial,
      );
      if (isSerialDuplicate) {
        NotificationExtension.Warn(
          `Mã serial "${serial}" đã tồn tại, vui lòng nhập mã khác`,
        );
        continue;
      }

      if (selectedItem) {
        const totalAddedQuantityForItem = tempSerials
          .filter((item) => item?.itemCode === selectedItem?.itemCode)
          ?.reduce((sum, item) => sum + (item.primaryQuantity || 0), 0);

        const totalPrimaryQuantityForItem = selectedItem?.primaryQuantity || 0;

        if (totalAddedQuantityForItem < totalPrimaryQuantityForItem) {
          tempSerials = [
            {
              ...selectedItem,
              serial,
              invId: dataInWard?.tblItemTransactionHeaderCommand?.sourceCode,
              primaryQuantity:
                dataInWard?.tblItemTransactionHeaderCommand?.primaryQuantity ??
                1,
              locatorId:
                dataInWard?.tblItemTransactionHeaderCommand?.toPositionId,
              positionCode: dataPosition?.find(
                (p) =>
                  p.value?.toString() ===
                  dataInWard?.tblItemTransactionHeaderCommand?.toPositionId?.toString(),
              )?.code,
            },
            ...tempSerials,
          ];
        } else {
          NotificationExtension.Warn(
            `Sản phẩm vượt quá số lượng cần nhập với serial "${serial}".`,
          );
          break;
        }
      } else {
        NotificationExtension.Warn(
          `Không tìm thấy sản phẩm tương ứng với serial "${serial}".`,
        );
      }
    }

    // Cập nhật trạng thái cuối cùng
    setDataSerialOnHand(tempSerials);
  };

  const updateItemByKeys = <T extends TblInventorySerialOrderDetailOnHandEdit>(
    prev: T[],
    serial: string,
    updates: Partial<T>,
  ): T[] => {
    return prev?.map((item) =>
      item.serial === serial ? { ...item, ...updates } : item,
    );
  };

  const notFetchDataSerialOnhand = (item: any) => {
    setSelectedItem(item);
    setCheckDuplicateCode((prev) => [...prev, item.itemCode]);
  };

  const handleDeleteSelected = () => {
    const filteredData = dataSerialOnHand?.filter(
      (row) =>
        !selectedRows.some(
          (selected) =>
            selected.serial === row.serial &&
            (selected.itemCode ? selected.itemCode === row.itemCode : true),
        ),
    );
    setDataSerialOnHand(filteredData);

    setCheckDuplicateCode((prevData) =>
      prevData.filter(
        (item) => !selectedRows.some((selected) => selected.serial === item),
      ),
    );
  };

  //#region  AG grid
  const containerStyle = React.useMemo(
    () => ({ width: "100%", height: height - 20, marginTop: "15px" }),
    [height],
  );

  const myTheme = themeQuartz.withParams({
    fontSize: 12,
    headerFontSize: 14,
    spacing: 5,
    wrapperBorder: true,
    headerRowBorder: true,
    rowBorder: { style: "solid", color: "#dee2e6" },
    columnBorder: { style: "solid", color: "#dee2e6" },
  });

  const getContextMenuItems = React.useCallback(
    (
      params: GetContextMenuItemsParams<TblInventorySerialOrderDetailOnHandEdit>,
    ): (DefaultMenuItem | MenuItemDef)[] => {
      const _number = Number(params?.node?.rowIndex) + 1 || "";
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        {
          // custom item
          name: "Xóa dòng thứ: " + _number,
          action: () => {
            if (!["DETAIL"].includes(action)) {
              deleteItemSerial(String(params?.node?.data?.serial));
            }
          },

          icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/3405/3405244.png" alt="icon"/></div>`,

          cssClasses: ["red", "bold"],
        },
        "separator",

        ...(["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
          ? [
              {
                name: "Import Excel ",
                shortcut: !keySearch
                  ? "Chưa chọn mã hàng"
                  : `<div style="color: red;">${keySearch}</div>`,
                action: () => {
                  handleFileUpload();
                },
                icon: `<div style="width: 15px; height: 18px; margin-left: 3px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/608/608336.png" alt="icon"/></div>`,
                disabled: !keySearch || ["DETAIL"].includes(action),
                cssClasses: ["red", "bold"],
              },
            ]
          : [
              {
                name: "Import Excel ",
                action: () => {
                  handleFileUpload();
                },
                disabled: ["DETAIL"].includes(action),
                cssClasses: ["red", "bold"],
                icon: `<div style="width: 15px; height: 18px; margin-left: 3px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/608/608336.png" alt="icon"/></div>`,
              },
            ]),
        {
          name: "Export Excel",
          action: () => {
            handleExportExcel();
          },
          cssClasses: ["red", "bold"],
          icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/9678/9678508.png" alt="icon"/></div>`,
        },
        // custom item},
        // {
        //   name: "Xuất Excel",
        //   action: () => {
        //     handleExportExcel();
        //   },
        //   cssClasses: ["red", "bold"],
        //   icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/9678/9678508.png" alt="icon"/></div>`,
        // },

        // {
        //   // custom item
        //   name: "Hủy đơn: " + _number, `
        //   action: () => {
        //     window.alert("Alerting about " + params.value);
        //   },
        //   cssClasses: ["red", "bold"],
        // },
        // "cut",
        // "cut",
        // "paste",
        "separator",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        // "separator",
        // "chartRange",
        // "export",
      ];
      return result;
    },
    [window, dataSerialOnHand, keySearch],
  );

  const getContextMenuItemsDetail = React.useCallback(
    (
      params: GetContextMenuItemsParams<TblInventorySerialOrderDetailOnHandEdit>,
    ): (DefaultMenuItem | MenuItemDef)[] => {
      const _number = Number(params?.node?.rowIndex) + 1 || "";
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        // custom item},
        // {
        //   name: "Xuất Excel",
        //   action: () => {
        //     handleExportExcel();
        //   },
        //   cssClasses: ["red", "bold"],
        //   icon: `<div style="width: 20px; height: 20px;"><img style="width: 100%; height: 100%; object-fit: contain;" src="https://cdn-icons-png.flaticon.com/512/9678/9678508.png" alt="icon"/></div>`,
        // },

        // {
        //   // custom item
        //   name: "Hủy đơn: " + _number, `
        //   action: () => {
        //     window.alert("Alerting about " + params.value);
        //   },
        //   cssClasses: ["red", "bold"],
        // },
        // "cut",
        // "cut",
        // "paste",
        "separator",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        // "separator",
        // "chartRange",
        // "export",
      ];
      return result;
    },
    [],
  );

  const defaultColDef = React.useMemo<
    ColDef<TblInventorySerialOrderDetailOnHandEdit>
  >(() => {
    return {
      editable: true,
      filter: false,
      floatingFilter: false,
      minWidth: 100,
    };
  }, []);

  const getRowClass = (params: any) => {
    if (!params.data) {
      return "row-error";
    }
    return "";
  };

  const onCellValueChanged = React.useCallback(
    (
      params: CellValueChangedEvent<TblInventorySerialOrderDetailOnHandEdit>,
    ) => {
      const colId = params.column.getId();
      //Hàm cập nhật giá trị vị trí
      if (colId === "locatorId") {
        setDataSerialOnHand((prev) => {
          return updateItemByKeys(prev, params?.data?.serial ?? "", {
            locatorId: params.data.locatorId?.toString(),
            positionCode: dataPosition?.find(
              (p) =>
                p.value?.toString() === params?.data?.locatorId?.toString(),
            )?.code,
          });
        });
      }
      //Hàm cập nhật giá trị số lượng
      if (colId === "primaryQuantity") {
        const checkNumber =
          dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
            (ele) =>
              ele.itemCode === params.data?.itemCode ||
              ele.serial === params.data?.serial,
          );

        const numberValue = params.data?.primaryQuantity;
        // Kiểm tra giá trị nhập
        const numericValue = Number(numberValue);
        if (!numberValue || isNaN(numericValue)) {
          NotificationExtension.Warn("Vui lòng nhập số lượng hợp lệ.");
          return;
        }
        //Hiển thị thông báo nếu vượt quá số lượng cho phép
        if (numericValue > Number(checkNumber?.primaryQuantity)) {
          NotificationExtension.Warn("Số lượng vượt quá số lượng cần nhập");
          return;
        }
      }
    },
    [dataPosition, dataSerialOnHand],
  );

  //Hàm check điều kiện điều chỉnh số lượng
  const isEditableField = (params: any) => {
    const x = dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
      (item) =>
        item.itemCode === params.data.itemCode ||
        item.serial === params.data.serial,
    );
    return x?.isNoSerial === true || params.data.isNoSerial === true;
  };

  //Hàm điều chỉnh số lượng
  const handlePrimaryQuantityChange = (
    params: CustomCellRendererProps,
    newValue: number,
  ) => {
    setDataSerialOnHand((prev) => {
      const item = prev?.find((item) => item.serial === params.data?.serial);
      if (!item) return prev;
      // Không thay đổi nếu giá trị không đổi
      if (item.primaryQuantity === newValue) return prev;

      return prev?.map((d) =>
        d.serial === params.data?.serial
          ? { ...d, primaryQuantity: newValue }
          : d,
      );
    });
  };

  //Hàm cập nhật khi chọn lại chính nó
  const onCellEditingStopped = React.useCallback(
    (
      params: CellEditingStoppedEvent<TblInventorySerialOrderDetailOnHandEdit>,
    ) => {
      const colId = params.column.getId();
    },
    [],
  );
  //#endregion
  //#region useEffects
  useEffect(() => {
    if (serialStatusSelectAll && String(serialStatusSelectAll).length > 0) {
      const dataSerialSet = dataSerialOnHand.map((i) => ({
        ...i,
        serialStatus: serialStatusSelectAll,
      }));

      setDataSerialOnHand(dataSerialSet);
    }
  }, [serialStatusSelectAll]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([
          fetchdataInventoryTransactionType(), // FetchData cho loại phiếu nhập
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const userLogin = localStorage.getItem("userLogin");
    if (userLogin) setUserInfo(JSON.parse(userLogin));

    // Chỉ load dữ liệu theo id/transactionCode ở đây.
    // Trường hợp CREATE theo sourceCode đã có useEffect theo sourceCode xử lý
    // (effect đó cũng chạy ở lần render đầu tiên) nên không gọi lại ở đây
    // để tránh call API 2 lần.
    if (id || transactionCode) {
      fetchData();
    }

    fetchAllData();
  }, []);

  useEffect(() => {
    setDataInWard((prevData) => ({
      ...prevData,
      tblItemTransactionHeaderCommand: {
        ...prevData.tblItemTransactionHeaderCommand,
        departmentId: userInfo?.depId || null,
      },
    }));
  }, [userInfo]);

  useEffect(() => {
    const _sourceType = dataInWard.tblItemTransactionHeaderCommand.sourceType;
    const handeSupplierRequest =
      _sourceType === "NHAP_HANG_NCC" || _sourceType === "NHAP_KHAC";
    const exceedQuantityFound =
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.some(
        (order) => {
          const matchingOrder = dataSerialOnHand
            .filter((item) => {
              const checkItem =
                item.serial === order.serial ||
                (handeSupplierRequest && item.itemCode === order.itemCode);
              return checkItem && !item.type;
            })
            .map((item) => item.primaryQuantity || 0);

          if (matchingOrder) {
            const totalQuantity = matchingOrder?.reduce(
              (acc, curr) => acc + curr,
              0,
            ); // Tính tổng số lượng

            const orderQuantity = order.primaryQuantity ?? 0;
            const orderTransferQuantity = order.transactionQuantity ?? 0;
            const remainQuantity =
              orderQuantity - (orderTransferQuantity + totalQuantity) || 0;
            return remainQuantity < 0;
          }

          return false;
        },
      );

    if (exceedQuantityFound) {
      setIsExceedQuantity(true);
    } else {
      setIsExceedQuantity(false);
    }

    setDataOrderDetail((prevData) => ({
      ...prevData,
      inventoryTransactionRequestSourceModels:
        prevData.inventoryTransactionRequestSourceModels?.map((order) => {
          const quantities = dataSerialOnHand
            .filter(
              (item) =>
                handeSupplierRequest
                  ? item.itemCode === order.itemCode
                  : item.serial === order.serial,
              // ? item.serial === order.serial
              // : item.itemCode === order.itemCode
            )
            .map((item) => item.primaryQuantity || 0);

          const totalQuantity = quantities?.reduce(
            (acc, curr) => acc + curr,
            0,
          );
          const orderQuantity = order.primaryQuantity ?? 0;
          const orderTransferQuantity = order.transactionQuantity ?? 0;
          const remainQuantity =
            orderQuantity - (orderTransferQuantity + totalQuantity);

          return {
            ...order,
            scannedQuantity: totalQuantity,
            remainQuantity: remainQuantity,
            primaryQuantity:
              _sourceType === "NHAP_THANH_PHAM_SAN_XUAT"
                ? 1
                : order.primaryQuantity,
          };
        }) ?? [],
    }));
  }, [dataSerialOnHand]);

  useEffect(() => {
    const _sourceType =
      dataInWard.tblItemTransactionHeaderCommand.sourceType ?? "";
    if (action === "DETAIL") {
      if (gridRef.current?.api) {
        gridRef.current.api.setColumnsVisible(["action"], true); // Ẩn cột action
      }
    }
    const colVisibilityDetail = visibleColDetail.get(_sourceType);
    const cosVisibility = visibleCol.get(_sourceType);

    if (_sourceType === "NHAP_THANH_PHAM_SAN_XUAT") {
      if (gridRef.current?.api) {
        gridRef.current.api.setColumnsVisible(
          ["subQuantity", "subUom", "subUomName", "subPrice"],
          false,
        );
      }
    }

    // if (colVisibilityDetail) {
    //   tableDetail.setColumnVisibility(colVisibilityDetail);
    // }

    // Clear input field
    if (action === "CREATE") {
      setDataSearchSourceCodeOption([]);
      setDataInWard({
        ...outWardEntity,
        tblItemTransactionHeaderCommand: {
          ...outWardEntity.tblItemTransactionHeaderCommand,
          sourceType: _sourceType,
          // sourceCode: null,
        },
      });
      setDataOrderDetail(entityOrderInWard);
      setDataSerialOnHand([]);
      setCheckDuplicateCode([]);
    }

    if (_sourceType) {
      setIsLockForOrder(_sourceType === "XUAT_BAN");
    } else {
      setIsLockForOrder(false);
    }
  }, [dataInWard.tblItemTransactionHeaderCommand.sourceType, gridRef.current]);

  useEffect(() => {
    if (action !== "CREATE") {
      return;
    }
    const _sourceType = dataInWard.tblItemTransactionHeaderCommand.sourceType;
    const _sourceCode = dataInWard.tblItemTransactionHeaderCommand.sourceCode;
    // Clear input field
    setDataInWard({
      ...outWardEntity,
      tblItemTransactionHeaderCommand: {
        ...outWardEntity.tblItemTransactionHeaderCommand,
        sourceType: _sourceType,
        sourceCode: _sourceCode,
      },
    });
    setDataOrderDetail(entityOrderInWard);
    setDataSerialOnHand([]);
    setCheckDuplicateCode([]);
  }, [dataInWard.tblItemTransactionHeaderCommand.sourceCode]);

  useEffect(() => {
    if (handleItemCode) {
      const autoSelectItems = dataItem?.filter(
        (item) => !checkDuplicateCode.includes(item.itemCode),
      );
      autoSelectItems.forEach((item) => {
        notFetchDataSerialOnhand(item);
        setCheckDuplicateCode((prev) => [...prev, item.itemCode]);
      });
    }
  }, [dataItem, handleItemCode]);

  useEffect(() => {
    const _sourceType = dataInWard.tblItemTransactionHeaderCommand.sourceType;
    if (
      _sourceType === "XUAT_BAN" &&
      dataOrderDetail?.inventoryTransactionRequestSourceModels.length > 0
    ) {
      const variance = checkVarianceItem(
        dataOrderDetail?.inventoryTransactionRequestSourceModels,
      );
      if (!variance.isVariance) {
        setIsLockForOrder(false);
      } else {
        setIsLockForOrder(true);
      }
    }
  }, [dataOrderDetail?.inventoryTransactionRequestSourceModels]);

  useEffect(() => {
    // Khi có id/transactionCode thì fetchData() đã lấy dữ liệu, không gọi thêm
    if (id || transactionCode) return;
    if (
      dataInWard.tblItemTransactionHeaderCommand?.sourceType &&
      dataInWard.tblItemTransactionHeaderCommand?.sourceCode &&
      action === "CREATE" &&
      sourceType !== "NHAP_HOI_LINH_KIEN"
    ) {
      fetchDataInWard();
    }
  }, [dataInWard.tblItemTransactionHeaderCommand?.sourceCode]);
  //chọn theo vị trí
  useEffect(() => {
    if (dataInWard?.tblItemTransactionHeaderCommand?.subInvId) {
      fetchDataPosition(dataInWard?.tblItemTransactionHeaderCommand?.subInvId);
    }
  }, [dataInWard?.tblItemTransactionHeaderCommand?.subInvId]);

  useEffect(() => {
    const _posId = dataInWard.tblItemTransactionHeaderCommand?.toPositionId;
    const _positionCode = dataPosition?.find(
      (p) =>
        p.value?.toString() ===
        dataInWard?.tblItemTransactionHeaderCommand?.toPositionId?.toString(),
    )?.code;
    if (_posId) {
      setDataSerialOnHand((prev) =>
        prev.map((i) => ({
          ...i,
          locatorId: _posId,
          positionCode: _positionCode,
        })),
      );
    }
  }, [dataInWard.tblItemTransactionHeaderCommand?.toPositionId]);

  useEffect(() => {
    if (debounced && debounced.length > 2) {
      fetchDataItem();
    } else {
      setDataItem([]);
    }
  }, [debounced, currentPage]);

  useEffect(() => {
    if (serialChildren.length > 0) {
      setDataSerialOnHand((prev) =>
        prev.map((item) => {
          const childSerial = serialChildren.find(
            (i) => i.parentSerial === item.serial,
          );

          let newSerialStatus: string | null = item.serialStatus;
          let newAttribute11: string | null | undefined = item.attribute11;
          if (
            childSerial?.serialStatus &&
            String(childSerial.serialStatus).length > 0
          ) {
            newSerialStatus = childSerial.serialStatus;
          }

          if (
            childSerial?.atrribute11 &&
            String(childSerial?.atrribute11).length > 0
          ) {
            newSerialStatus = childSerial.atrribute11;
          }

          return {
            ...item,
            check: true,
            serialStatus: newSerialStatus,
            attribute11: newAttribute11,
            tblInventoryChildSerialOnhandCommands: [
              ...(item.tblInventoryChildSerialOnhandCommands || []),
              ...serialChildren.filter(
                (cmd: TblInventoryChildSerialOnhandCommand) =>
                  cmd.serial && cmd.parentSerial === item.serial,
              ),
            ],
          };
        }),
      );
    }
  }, [serialChildren]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (310 + headerHeight));
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const updateMainContentWidth = () => {
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const sidePanelWidth = sidePanelRef.current?.offsetWidth || 0;
      const calculatedMainWidth = isCollapse
        ? containerWidth
        : containerWidth - sidePanelWidth;
      setMainContentWidth(calculatedMainWidth);
    };

    const containerObserver = new ResizeObserver(updateMainContentWidth);
    const sidePanelObserver = new ResizeObserver(updateMainContentWidth);

    if (containerRef.current) containerObserver.observe(containerRef.current);
    if (sidePanelRef.current) sidePanelObserver.observe(sidePanelRef.current);

    updateMainContentWidth();
    return () => {
      if (containerRef.current)
        containerObserver.unobserve(containerRef.current);
      if (sidePanelRef.current)
        sidePanelObserver.unobserve(sidePanelRef.current);
    };
  }, [isCollapse]);
  //#endregion AG grid

  //#region serial on hand
  const columnDefs = React.useMemo<
    ColDef<TblInventorySerialOrderDetailOnHandEdit>[]
  >(
    () => [
      {
        headerName: "STT",
        field: "index",
        pinned: "left",
        editable: false,
        minWidth: 80,
        maxWidth: 80,
        valueGetter: (params) => Number(params?.node?.rowIndex) + 1,
      },
      {
        field: "positionCode",
        headerName: "Mã vị trí",
        filter: "agTextColumnFilter",
        editable: false,
        sortable: false,
      },
      {
        field: "locatorId",
        cellEditor: "agRichSelectCellEditor",
        filter: "agTextColumnFilter",
        headerName: "Vị trí kho",
        editable: false,
        minWidth: 270,
        cellRenderer: (params: any) => {
          const locatorId = params?.data?.locatorId?.toString();
          const positionName = params?.data?.positionName;
          const isDisabled =
            dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
            locker;
          const handleChange = (value: string | null) => {
            if (value) {
              setDataSerialOnHand((prev: any) =>
                updateItemByKeys(prev, params?.data?.serial, {
                  locatorId: String(value),
                  positionCode: dataPosition?.find(
                    (p) => p.value?.toString() === value?.toString(),
                  )?.code,
                }),
              );
            }
          };
          return !locker ? (
            <Select
              mt={-3}
              variant="transparent"
              key={locatorId}
              className={classesButton.text_input}
              searchable
              disabled={isDisabled}
              flex={1}
              data={dataPosition}
              value={locatorId}
              onChange={handleChange}
            />
          ) : (
            <>{positionName}</>
          );
        },
        valueFormatter: (params) => {
          const data = dataPosition?.find(
            (ele) => String(ele.value) === String(params.data?.locatorId),
          );
          return data ? data.label : params.value;
        },
      },
      {
        field: "itemCode",
        headerName: "Mã hàng",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "serial",
        headerName: "Serial",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 150,
      },
      {
        field: "itemName",
        headerName: "Tên SP",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 150,
        maxWidth: 300,
      },
      {
        field: "primaryUomName",
        headerName: "ĐVT1",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 50,
        valueGetter: (params) => {
          const data = params.data?.primaryUomName
            ? params.data?.primaryUomName
            : (params.data?.primaryUomCode ?? params.data?.primaryUom);
          return data;
        },
      },
      {
        field: "primaryQuantity",
        headerName: "SL1",
        editable: (params: any) => isEditableField(params),
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        cellEditorParams: (params: CustomCellRendererProps) => {
          const data =
            dataOrderDetail?.inventoryTransactionRequestSourceModels?.find(
              (ele) =>
                ele.itemCode === params.data?.itemCode ||
                ele.serial === params.data?.serial,
            );
          const maxQuantity = data?.primaryQuantity;
          return {
            values: [0, maxQuantity],
            min: 0,
            max: maxQuantity,
          } as IRichCellEditorParams;
        },
        valueSetter: (params: any) => {
          const newValue = params.newValue;
          handlePrimaryQuantityChange(params, newValue);
          params.data.primaryQuantity = newValue;
          return true;
        },
      },
      {
        field: "poPrice",
        headerName:
          dataInWard?.tblItemTransactionHeaderCommand?.sourceType === "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 100,
        valueGetter: (params) => {
          const x =
            dataInWard?.tblItemTransactionHeaderCommand?.sourceType ===
            "XUAT_BAN"
              ? params.data?.soPrice && params.data?.soPrice?.toLocaleString()
              : params.data?.poPrice && params.data?.poPrice?.toLocaleString();
          return x;
        },
      },
      {
        field: "returnReason",
        headerName: "Lý do đổi trả",
        editable: false,
      },
      {
        field: "subQuantity",
        headerName: "SL2",
        editable: false,
        cellEditor: "agNumberCellEditor",
        filter: "agNumberColumnFilter",
        minWidth: 100,
      },
      {
        field: "subUomName",
        headerName: "ĐVT2",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 100,
      },
      {
        field: "totalAmount",
        headerName: "Thành tiền",
        editable: false,
        cellEditor: "agNumberCellEditor",
        filter: "agNumberColumnFilter",
        minWidth: 100,
        valueGetter: (params) => {
          const x =
            dataInWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
              ? params.data?.soPrice &&
                (
                  Number(params.data?.soPrice) *
                  (params.data?.primaryQuantity || 0)
                )?.toLocaleString()
              : params.data?.poPrice &&
                (
                  Number(params.data?.poPrice) *
                  Number(params.data?.primaryQuantity || 0)
                )?.toLocaleString();
          return x;
        },
      },
      {
        field: "serialStatus",
        headerName: "Tình trạng",
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
          values: dataSerialStatus.map((i: any) => String(i.label)),
          cellRenderer: SerialStatusCustomAgGrid,
          allowTyping: true,
          filterList: true,
          highlightMatch: true,
          valueListMaxWidth: 180,
        },
        filter: "agTextColumnFilter",
        minWidth: 100,
      },
      {
        field: "attribute11",
        headerName: "Ghi chú tình trạng",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
      {
        field: "note",
        headerName: "Ghi chú",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
      {
        field: "action",
        headerName: "Thao Tác",
        pinned: "right",
        cellRenderer: (params: any) => {
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {![
                "NHAP_THANH_PHAM_SAN_XUAT",
                "NHAP_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
              ].includes(
                sourceType ??
                  dataInWard.tblItemTransactionHeaderCommand.sourceType,
              ) && (
                <Tooltip
                  label={`${
                    params?.data?.tblInventoryChildSerialOnhandCommands
                      ?.length > 0
                      ? "Thông tin serial con"
                      : "Chưa có serial con"
                  } `}
                >
                  <ActionIcon
                    // disabled={!row?.original?.check}
                    onClick={() => {
                      return openModal(params?.data);
                    }}
                    bd={
                      "0.3px solid " +
                      (params?.data?.tblInventoryChildSerialOnhandCommands
                        ?.length > 0
                        ? "violet"
                        : "orange")
                    }
                    variant="light"
                    aria-label="Settings"
                    color={
                      params?.data?.tblInventoryChildSerialOnhandCommands
                        ?.length > 0
                        ? "violet"
                        : "orange"
                    }
                  >
                    <IconPencilDiscount size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              )}
              <Tooltip label="Xóa">
                <ActionIcon
                  disabled={
                    dataInWard.tblItemTransactionHeaderCommand.status ===
                      "LOCK" || action === "DETAIL"
                  }
                  variant="light"
                  aria-label="Settings"
                  color="red"
                  onClick={async () => {
                    deleteItemSerial(params.data.serial);
                  }}
                >
                  <IconTrash size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Box>
          );
        },
        editable: false,
        minWidth: 100,
        maxWidth: 100,
      },
    ],
    [
      dataSerialOnHand,
      dataInWard.tblItemTransactionHeaderCommand.toPositionId,
      dataInWard.tblItemTransactionHeaderCommand.sourceType,
      dataInWard.tblItemTransactionHeaderCommand.status,
      locker,
      dataPosition,
      dataSerialStatus,
    ],
  );

  //#region Chi tiết bên xuất

  const columnsOrderDetail = React.useMemo<
    ColDef<TblInventorySerialOrderDetailOnHandEdit>[]
  >(
    () => [
      {
        headerName: "STT",
        field: "index",
        pinned: "left",
        editable: false,
        minWidth: 80,
        maxWidth: 80,
        valueGetter: (params) => Number(params?.node?.rowIndex) + 1,
      },
      {
        field: "itemCode",
        headerName: "Mã hàng",
        filter: "agTextColumnFilter",
        editable: false,
        sortable: false,
        cellRenderer: ({ value, data }: any) => {
          return ["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType) ? (
            <Button
              onClick={() => {
                setHandleItemCode(true);
                setKeySearch(data.itemCode);
                setSerial("");
                notFetchDataSerialOnhand(data);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              style={{
                color: "#228be6",
                background: "transparent",
                border: "none",
                fontWeight: 700,
                padding: "4px 8px",
                cursor: "pointer",
              }}
            >
              {value}
            </Button>
          ) : (
            <span
              onClick={() => {
                setKeySearch(data.itemCode);
                setIsMenuNone(false);
                setSerial("");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              style={{
                color: "#228be6",
                fontWeight: 700,
                cursor: "pointer",
                padding: "4px 8px",
                display: "inline-block",
              }}
            >
              {value}
            </span>
          );
        },
      },
      ...(["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
        ? []
        : [
            {
              field: "serial" as keyof TblInventorySerialOrderDetailOnHandEdit,
              headerName: "Serial",
              width: 100,
              editable: false,
              cellEditor: "agTextCellEditor",
              filter: "agTextColumnFilter",
            },
          ]),
      {
        field: "itemName",
        headerName: "Tên sản phẩm",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
      {
        field: "primaryUom",
        headerName: "ĐVT1",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 100,
      },
      {
        field:
          "primaryQuantity" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "SL1",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        width: 30,

        cellRenderer: ({ value, data }: any) => {
          return (
            <span style={{ fontSize: "0.875rem" }}>
              {dataInWard.tblItemTransactionHeaderCommand.sourceType ===
              "NHAP_THANH_PHAM_SAN_XUAT"
                ? 1
                : value}
            </span>
          );
        },
      },
      {
        field: "poPrice" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName:
          dataInWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
            ? "Giá bán"
            : "Giá nhập",
        minWidth: 150,
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        cellRenderer: ({ value, data }: any) => {
          return (
            <span style={{ fontSize: "0.875rem" }}>
              {dataInWard.tblItemTransactionHeaderCommand.sourceType ===
              "XUAT_BAN"
                ? data?.soPrice1?.toLocaleString() || ""
                : value?.toLocaleString() || ""}
            </span>
          );
        },
        footerValueGetter: (params: any) => {
          const total = params.api
            .getDisplayedRowCount()
            ?.reduce(
              (sum: number, rowNode: any) => sum + (rowNode.data?.poPrice || 0),
              0,
            );

          return new Intl.NumberFormat().format(total);
        },
      },
      {
        field: "returnReason" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "Lý do đổi trả",
        minWidth: 100,
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
      },
      {
        field: "subQuantity",
        headerName: "SL2",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        width: 30,
      },
      ...(["NHAP_HANG_NCC", "NHAP_KHAC"].includes(sourceType)
        ? []
        : [
            {
              field:
                "limitQuantity" as keyof TblInventorySerialOrderDetailOnHandEdit,
              headerName: "SL định mức",
              minWidth: 100,
              editable: false,
            },
          ]),

      {
        field: "subPrice",
        headerName: "Giá theo ĐVT2",
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 70,
      },
      {
        field: "totalAmount" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "Thành tiền",
        minWidth: 100,
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        valueFormatter: (params) => {
          const { soPrice1, poPrice, primaryQuantity = 0 } = params.data || {};
          const isSale =
            dataInWard.tblItemTransactionHeaderCommand.sourceType ===
            "XUAT_BAN";

          const total = isSale
            ? (soPrice1 || 0) * (primaryQuantity ?? 0)
            : (poPrice || 0) * (primaryQuantity ?? 0);

          return total ? total?.toLocaleString() : "0";
        },
      },
      {
        field: "itemStatus" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "Tình trạng",
        minWidth: 100,
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
      },
      {
        field: "note" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "Ghi chú",
        minWidth: 70,
        editable: false,
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
      },
      {
        field: "deviated" as keyof TblInventorySerialOrderDetailOnHandEdit,
        headerName: "Lệch",
        editable: false,
        pinned: "right",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        width: 30,
        cellRenderer: (params: any) => {
          const { scannedQuantity = 0, primaryQuantity = 0 } =
            params.data || {};
          const deviatedValue = scannedQuantity - primaryQuantity;
          return (
            <Text fw="bolder" c={"red"}>
              {deviatedValue}
            </Text>
          );
        },
      },
    ],
    [
      dataSerialOnHand,
      dataInWard.tblItemTransactionHeaderCommand.sourceType,
      isMenuNone,
      setIsMenuNone,
    ],
  );

  const pinnedBottomRowData = React.useMemo(() => {
    const totalAmount =
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.reduce(
        (sum, row) => {
          const quantity = row.primaryQuantity || 0;
          const price =
            dataInWard.tblItemTransactionHeaderCommand.sourceType === "XUAT_BAN"
              ? Number(row.soPrice1 || 0)
              : Number(row.poPrice || 0);
          return sum + price * quantity;
        },
        0,
      );

    return [`${totalAmount?.toLocaleString()}`];
  }, [dataOrderDetail?.inventoryTransactionRequestSourceModels]); // Thêm dependencies

  const totalSellingPrice = React.useMemo(() => {
    const totalAmount =
      dataOrderDetail?.inventoryTransactionRequestSourceModels?.reduce(
        (sum, row) => {
          const price = Number(row.poPrice || 0);
          return sum + price;
        },
        0,
      );

    return [`${totalAmount?.toLocaleString()}`];
  }, [dataOrderDetail?.inventoryTransactionRequestSourceModels]); // Thêm dependencies
  //#endregion

  return (
    <Box>
      <Modal
        opened={openModals}
        onClose={() => setOpenModal(false)}
        zIndex={2000}
        title={<Title order={4}>Vui lòng chọn Sheet từ file excel</Title>}
      >
        {sheetNames.map((sheet, index) => (
          <Checkbox
            mt={15}
            key={index}
            label={<Text fw={500}>{sheet}</Text>}
            checked={selectedSheets.includes(sheet)}
            onChange={(e) => {
              setSelectedSheets(e.target.checked ? [sheet] : []); //chỉ chọn 1
              // setSelectedSheets((prev) =>
              //   e.target.checked
              //     ? [...prev, sheet]   //Cho chọn nhiều
              //     : prev.filter((item) => item !== sheet)
              // );
            }}
          />
        ))}
        <Group mt={15} justify="flex-end">
          <Button
            leftSection={<IconCheck size={16} />}
            onClick={handleSheetSelection}
            color="#228be6"
            variant="filled"
          >
            Xác nhận
          </Button>
        </Group>
      </Modal>
      <_breadcrumb></_breadcrumb>
      <Flex
        ref={headerRef}
        direction={"row"}
        justify={"space-between"}
        align={"center"}
      >
        <Flex align={"center"} gap={20}>
          <Group gap={20}>
            <Text c={"red"} fw={700}>
              Loại phiếu
            </Text>
            <Select
              searchable
              clearable
              w={300}
              className={classesButton.text_input}
              placeholder="Chọn loại phiếu"
              disabled={
                dataInWard.tblItemTransactionHeaderCommand.status === "LOCK" ||
                sourceCode ||
                isSave
              }
              data={dataInventoryTransactionType}
              value={
                dataInWard.tblItemTransactionHeaderCommand.sourceType?.toString() ||
                ""
              }
              onChange={(value) => {
                handleChangeValueInput(value || "", "sourceType");
              }}
            />
          </Group>
        </Flex>
        <Box my={"10px"}>{titleSell()}</Box>
      </Flex>
      <Box
        style={{
          maxHeight: `${height}px`,
          minHeight: `${height}px`,
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            width: "max-width",
          }}
          ref={containerRef}
        >
          {!isCollapse && (
            <Box
              style={{
                flexShrink: 0,
                transition: "width 0.3s ease, max-width 0.3s ease",
                display: "flex",
                position: "sticky",
                top: "60px",
                alignItems: "stretch",
                overflow: "hidden",
                height: "100%",
                width: "fit-content",
              }}
              ref={sidePanelRef}
            >
              <Collapse
                in={!isCollapse}
                transitionDuration={100}
                transitionTimingFunction="ease-in-out"
              >
                <Fieldset
                  w="fit-content"
                  h="100%"
                  legend="Thông tin chung"
                  p={5}
                >
                  {renderMainInWard()}
                </Fieldset>
              </Collapse>
            </Box>
          )}
          <Box
            style={{
              flexGrow: 1,
              flexShrink: 0,
              width: `${mainContentWidth}px`,
              transition: "width 0.3s ease",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Group pt={0}>
              <Fieldset w={"100%"} p={10} pb={5} legend="Bên nhận">
                <Group>
                  <Flex gap={15} style={{ width: "100%" }}>
                    <Flex gap={15} justify="start" align={"center"}>
                      {RenderTransactionHeader(1)}
                    </Flex>
                    <Flex gap={15} justify="start" align={"center"}>
                      {RenderTransactionHeader(2)}
                    </Flex>
                    {/* <RenderAddBarcodeButton /> */}
                    <Flex gap={15} justify="start" align={"center"}>
                      <RenderSerialButtons />
                    </Flex>
                    <Flex
                      direction="row"
                      align="center"
                      justify="flex-end"
                      w="100%"
                      pr={20}
                      gap={15}
                    >
                      <Text fw={700}>Số lượng:</Text>
                      <Text c="red" fw={700}>
                        <NumberFormatter
                          value={
                            dataSerialOnHand?.reduce(
                              (total, ele) =>
                                total + Number(ele.primaryQuantity),
                              0,
                            ) || 0
                          }
                          thousandSeparator
                        />
                      </Text>
                    </Flex>
                  </Flex>
                </Group>
                <div style={containerStyle}>
                  <AgGridReact<TblInventorySerialOrderDetailOnHandEdit>
                    ref={gridRef}
                    cellSelection={true}
                    onCellValueChanged={onCellValueChanged}
                    onCellEditingStopped={onCellEditingStopped}
                    rowData={dataSerialOnHand}
                    theme={myTheme}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    suppressColumnVirtualisation={true}
                    suppressRowVirtualisation={true}
                    pagination={true}
                    localeText={AG_GRID_LOCALE_VN}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    onSelectionChanged={() =>
                      setSelectedRows(
                        gridRef.current?.api.getSelectedRows() || [],
                      )
                    }
                    getContextMenuItems={getContextMenuItems}
                    cacheBlockSize={paginationPageSize}
                    maxBlocksInCache={3}
                    getRowClass={getRowClass}
                    suppressRowHoverHighlight={true}
                    columnHoverHighlight={true}
                    rowSelection={{ mode: "multiRow" }}
                    autoSizeStrategy={{
                      type: "fitCellContents",
                    }}
                    //  getContextMenuItems={getContextMenuItems}
                  />
                  {/* <MantineReactTable table={table} /> */}
                  <Group my="10px" justify="end" />
                </div>
              </Fieldset>
            </Group>
            <Fieldset p={10} pb={0} w={"max-width"} legend={"Bên xuất"}>
              <Box ref={targetRef as React.RefObject<HTMLDivElement>}>
                <Flex p={2} justify="space-between" align="center">
                  <Text c="red" fw={700}>
                    Tổng
                  </Text>
                  <Flex gap="10px">
                    <Flex c="red" gap={10} fw={700}>
                      <Text fw={700}>Giá nhập</Text>
                      <Text fw={700}>{`${totalSellingPrice}`}</Text>
                    </Flex>
                    <Divider size="lg" orientation="vertical" />
                    <Flex c="red" gap={10} fw={700}>
                      <Text fw={700}>Thành tiền</Text>
                      <Text fw={700}>{`${pinnedBottomRowData}`}</Text>
                    </Flex>
                  </Flex>
                </Flex>
                <div style={containerStyle}>
                  <AgGridReact<any>
                    ref={gridRefDetail}
                    cellSelection={true}
                    onCellValueChanged={onCellValueChanged}
                    onCellEditingStopped={onCellEditingStopped}
                    rowData={
                      dataOrderDetail?.inventoryTransactionRequestSourceModels
                    }
                    theme={myTheme}
                    columnDefs={columnsOrderDetail}
                    defaultColDef={defaultColDef}
                    suppressColumnVirtualisation={true}
                    suppressRowVirtualisation={true}
                    pagination={true}
                    localeText={AG_GRID_LOCALE_VN}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    getContextMenuItems={getContextMenuItemsDetail}
                    cacheBlockSize={paginationPageSize}
                    maxBlocksInCache={3}
                    getRowClass={getRowClass}
                    suppressRowHoverHighlight={true}
                    columnHoverHighlight={true}
                    // autoSizeStrategy={{
                    //   type: "fitCellContents",
                    // }}
                    //  getContextMenuItems={getContextMenuItems}
                  />
                  {/* <MantineReactTable table={table} /> */}
                  <Group my="10px" justify="end" />
                </div>
                {/* <MantineReactTable table={tableDetail} /> */}
              </Box>
            </Fieldset>
          </Box>
        </Box>
      </Box>
      {/* {dataPrint && typePrint && ( */}
      <Box style={{ display: "none" }}>
        {dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
          "NHAP_DOI_TRA" ||
        dataInWard?.tblItemTransactionHeaderCommand?.sourceType ==
          "NHAP_DOI_TRA_TRUOC_2025" ? (
          <>
            <PrintTheReturnReceipt
              dataPrint={dataPrint}
              typePrint={
                dataInWard?.tblItemTransactionHeaderCommand?.sourceType
              }
              userInfo={userInfo}
              currentDate={currentDate}
              componentRef={componentRef}
              dataCommuneMoi={dataCommuneMoi}
            />
          </>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};
export default WarehouseInWardActionV2;
